import { id } from '@swimlane/ngx-charts';
import { element } from 'protractor';
import { map } from 'rxjs/operators';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from "@angular/material/table";
import { HttpService } from 'src/app/services/http/http.service';
import { NgSelectModule, NgOption } from '@ng-select/ng-select';
import { Spinkit } from 'ng-http-loader';
import { __values } from 'tslib';
import { TooltipPosition } from '@angular/material/tooltip';
import { FormControl } from '@angular/forms';
@Component({
  selector: 'app-d2-all-resto',
  templateUrl: './d2-all-resto.component.html',
  styleUrls: ['./d2-all-resto.component.scss']
})
export class D2AllRestoComponent implements OnInit {
  allRestaurantList: any[] = []
  restaurantList: any[] = []
  displayedColumns: string[] = [
    "id",
    "name",
    "info",
    "status",
  ];

  dataSource: MatTableDataSource<[]> = new MatTableDataSource(
    this.restaurantList
  );
  // ---------------------------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------------------------
  allDieatary = [];
  allAllergens = []
  allCaategory = []
  allCuisine = []
  selectedCityIds: string[];
  selectedDieatry = []
  selectedAllegens = []
  selectedCaategory = []
  selectedCuisine = []
  monOpenHH = ''
  monOpenMM = ''
  monOpenMead = 'am'
  monPrecheck
  monCloseHH = ''
  monCloseMM = ''
  monCloseMead = 'am'
  tueOpenHH = ''
  tueOpenMM = ''
  tueOpenMead = 'am'
  tueCloseHH = ''
  tueCloseMM = ''
  tueCloseMead = 'am'
  tuePrecheck
  wedOpenHH = ''
  wedOpenMM = ''
  wedOpenMead = 'am'
  wedCloseHH = ''
  wedCloseMM = ''
  wedCloseMead = 'am'
  wedPrecheck
  thurOpenHH = ''
  thurOpenMM = ''
  thurOpenMead = 'am'
  thurCloseHH = ''
  thurCloseMM = ''
  thurCloseMead = 'am'
  thurPrecheck
  friOpenHH = ''
  friOpenMM = ''
  friOpenMead = 'am'
  friCloseHH = ''
  friCloseMM = ''
  friCloseMead = 'am'
  friPrecheck
  satOpenHH = ''
  satOpenMM = ''
  satOpenMead = 'am'
  satCloseHH = ''
  satCloseMM = ''
  satCloseMead = 'am'
  satPrecheck
  sunOpenHH = ''
  sunOpenMM = ''
  sunOpenMead = 'am'
  sunCloseHH = ''
  sunCloseMM = ''
  sunCloseMead = 'am'
  sunPrecheck
  mondayClearCondition = false
  tuesdayClearCondition = false
  wednesdayClearCondition = false
  tursdayClearCondition = false
  fridayClearCondition = false
  saturdayClearCondition = false
  sundayClearCondition = false

  offerMonday = false
  offerTuesday = false
  offerWednesday = false
  offerTurusday = false
  offerFriday = false
  offerSaturday = false
  offerSunday = false
  offerMonValue = ''
  offerTueValue = ''
  offerWedValue = ''
  offerThurValue = ''
  offerFriValue = ''
  offerSatValue = ''
  offerSunValue = ''

  queAns = ''
  queAnsOtherText = ''
  otherDescriptionOrTags = ''
  constructor(
    public dialog: MatDialog,
    private httpSv: HttpService,
    private _snackBar: MatSnackBar
  ) { }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit(): void {
    // this.getData();
    this.selectAllForDropdownItems(this.getAllergens())
    this.selectAllForDropdownItems(this.getData());
    this.selectAllForDropdownItems(this.getCuisine());
    this.selectAllForDropdownItems(this.getCategory());
    // this.getAllResto()
    this.claimRestoList()
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  positionOptions: TooltipPosition[] = ['below', 'above', 'left', 'right'];
  position = new FormControl(this.positionOptions[0]);
  public spinkit = Spinkit;
  src: string = "../../../assets/images/Ellipse 11.png";
  featureSrc: string = '../../../assets/images/Ellipse 11.png'
  restopop: number = 1
  searchText: string
  restoName
  restoEmail
  restoPhone
  restoAddress
  restoDescrip
  restoStreetName
  restoCity
  restoAvgRating
  restoLotitude
  restoLogitude
  restoServiceCharge
  spiceTol
  noOfTable
  offerValue
  restoMapLink
  menuSrc: any[] = []
  noResto: number
  foodbudMenu
  restoTrusted
  menuPdfCondition
  menuImgCondition
  pdfMenuSrc = 'null'
  menuLinkCondition = false
  urlLink = ''
  sendData: any = new FormData()
  currentRestoId: any = null
  foodMenuAvalaible
  trusted
  pdfRedirctVar
  logoToBeAppend: any = null
  featureImgToBeAppend: any = null
  menuImgToBeAppend: any[] = []
  menuPdfToBeAppend: any = null
  csvRestoFlag = false;
  claimedRestoFlag = false;
  partialClaimFlag = true;



  claimRestoList() {
    this.claimedRestoFlag = true;
    this.csvRestoFlag = false;
    this.partialClaimFlag = false;
  }

  partialClaimRestoList() {
    this.partialClaimFlag = true;
    this.claimedRestoFlag = false;
    this.csvRestoFlag = false;
  }
  filter() {
    if (this.searchText == "") {
      this.dataSource = new MatTableDataSource(this.restaurantList);
      this.dataSource.paginator = this.paginator;
    } else {
      let temp = this.restaurantList.filter((ele: any) => {
        return ele.restaurant_name
          .toLocaleLowerCase()
          .match(this.searchText.toLocaleLowerCase());
      });
      this.dataSource = new MatTableDataSource(temp);

      if (temp.length === 0) {
        let temp = this.restaurantList.filter((ele: any) => {
          return ele.unique_id
            .toLocaleLowerCase()
            .match(this.searchText.toLocaleLowerCase());
        });
        this.dataSource = new MatTableDataSource(temp);
      }
      this.dataSource.paginator = this.paginator;
    }
  }
  onImageChange(event, id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    if (fileSize > 500) {
      this._snackBar.open(`Image can't be uploaded, as the size is bigger than 500 kb`)
      setTimeout(() => { this._snackBar.dismiss() }, 3000)
      document.getElementById(id)['value'] = ''
      // alert(`Sorry this is can't be uploaded .The image size is greater than 500kb`)
      return
    }
    this.logoToBeAppend = event.target.files[0]
    let file: File = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.src = e.target.result;
      document.getElementById(id)['value'] = ''
    };
  }
  addResto() {
    // console.log('add')
  }
  updateRestoFunc(data) {
    this.currentRestoId = data
    this.httpSv.getOneD2RestoDetails(data).subscribe(res => {
      if (res['status'] == 'TRUE') {
        let temp = res['result'].data
        // dp
        if (typeof (temp.dietary_preferences) != 'string') {
          this.selectedDieatry = temp.dietary_preferences.map(element => {
            return element.diet_preference_id
          });
        }
        // allegens
        if (typeof (temp.allergens) != 'string') {
          this.selectedAllegens = temp.allergens.map(element => {
            return element.allergens_id
          });
        }
        //Category
        if (typeof (temp.categories) != 'string') {
          this.selectedCaategory = temp.categories.map(element => {
            return element.category_id
          });
        }
        // Cuisine
        if (typeof (temp.cuisines) != 'string') {
          this.selectedCuisine = temp.cuisines.map(element => {
            return element.cuisine_id
          });
        }

        this.restoName = temp.restaurant_name
        this.restoEmail = temp.restaurant_email
        this.restoAddress = temp.restaurant_address
        this.restoDescrip = temp.description
        this.restoPhone = temp.contact_no
        this.restoLogitude = temp.longitude
        this.restoLotitude = temp.latitude
        this.restoMapLink = temp.google_map_url
        this.offerValue = temp.special_offer
        if (temp.logo) {
          this.src = temp.logo
        }
        this.restoStreetName = temp.street
        this.restoCity = temp.city
        this.restoAvgRating = temp.average_rating
        if (temp.foodbud_menu_available == 'Yes') {
          this.foodMenuAvalaible = 'Yes'
          this.foodbudMenu = true
        }
        else {
          this.foodMenuAvalaible = 'No'
          this.foodbudMenu = false
        }
        if (temp.trusted == 'Yes') {
          this.trusted = 'Yes'
          this.restoTrusted = true
        }
        else {
          this.trusted = 'No'
          this.restoTrusted = false
        }
        if (temp.featured_image) this.featureSrc = temp.featured_image
        if (temp.menu_name_link) {
          let menuNameLink = temp.menu_name_link
          // if (temp.menu_name_link.length > 1) menuNameLink = temp.menu_name_link[0].split(',')
          // else menuNameLink = temp.menu_name_link[0]
          console.log(menuNameLink[0].includes('.jpg'))
          if (menuNameLink[0].includes('.pdf') || menuNameLink.length > 1 || menuNameLink[0].includes('.png') || menuNameLink[0].includes('.jpg') || menuNameLink[0].includes('.jpeg') || menuNameLink[0].includes('.svg')) {
            console.log('menuNameLink[0].includes()')
            if (temp.menu_name) {
              if (temp.menu_name[0].includes('.pdf')) {
                this.menuPdfCondition = true
                this.pdfRedirctVar = temp.menu_name[0]
                let splitArr = temp.menu_name[0].split('/')
                this.pdfMenuSrc = splitArr[splitArr.length - 1]
                this.pdfConditionMenu = true
              }
              else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg'))) {
                this.menuImgCondition = true
                temp.menu_name.forEach(element => {
                  this.menuSrc.push({ src: element })
                });
                this.imgConditionMenu = true
              }
            }
            if (temp.menu_name_link) {
              let menuNameLink = temp.menu_name_link
              if (menuNameLink[0].includes('.pdf')) {
                this.menuPdfCondition = true
                this.pdfRedirctVar = temp.menu_name[0]
                let splitArr = temp.menu_name[0].split('/')
                this.pdfMenuSrc = splitArr[splitArr.length - 1]
                this.pdfConditionMenu = true
              }
              else if ((menuNameLink.length > 1 || menuNameLink[0].includes('.png') || menuNameLink[0].includes('.jpg') || menuNameLink[0].includes('.jpeg') || menuNameLink[0].includes('.svg')) && typeof (menuNameLink) != 'string') {
                // console.log('works 2')
                this.menuImgCondition = true
                menuNameLink.forEach(element => {
                  this.menuSrc.push({ src: element })
                });
                this.imgConditionMenu = true
              }
            }
          }
          else {
            this.menuLinkCondition = true
            this.urlLink = menuNameLink
          }
        }
        else {
          if (temp.menu_name) {
            if (temp.menu_name[0].includes('.pdf')) {
              this.menuPdfCondition = true
              this.pdfRedirctVar = temp.menu_name[0]
              let splitArr = temp.menu_name[0].split('/')
              this.pdfMenuSrc = splitArr[splitArr.length - 1]
              this.pdfConditionMenu = true
            }
            else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg')) && typeof (temp.menu_name) != 'string') {
              this.menuImgCondition = true
              temp.menu_name.forEach(element => {
                this.menuSrc.push({ src: element })
              });
              this.imgConditionMenu = true
            }
          }
        }
        // if (temp.menu_name[0].includes('.pdf')) {
        //   this.menuPdfCondition = true
        //   this.pdfRedirctVar = temp.menu_name[0]
        //   let splitArr = temp.menu_name[0].split('/')
        //   this.pdfMenuSrc = splitArr[splitArr.length - 1]
        //   this.pdfConditionMenu = true
        // }
        // else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg')) && typeof (temp.menu_name) != 'string') {
        //   this.menuImgCondition = true
        //   temp.menu_name.forEach(element => {
        //     this.menuSrc.push({ src: element })
        //   });
        //   this.imgConditionMenu = true
        // }



        // ------------------------------------------------------------------------------------------------------------
        if (temp.opening_hours) {
          let time = temp.opening_hours.split(',')
          time.forEach(element => {
            element = element.replaceAll(/\s/g, '')
            let temp1
            let dayTime
            let openHH
            let openMM
            let openMead = 'am'
            let closeHH
            let closeMM
            let closeMead = 'am'
            let flag
            let [day, ...time] = element.split(':')
            dayTime = time.join(':')
            dayTime = dayTime.replace('[', '')
            dayTime = dayTime.replace(']', '')
            temp1 = dayTime.split('-')
            if (temp1[0] != 'Closed') {

              if (temp1[0].includes(':')) {
                let temp = temp1[0].split(':')
                openHH = temp[0]
                if (temp[1].length > 2) {
                  let num = temp[1].match(/\d+/g);
                  let letr = temp[1].match(/[a-zA-Z]+/g);
                  openMM = num[0]
                  openMead = letr[0]
                  flag = true
                }
                else {
                  openMM = temp1[1]
                  flag = false
                }
              }
              else {
                openMM = '00'
                if (temp1[0].length > 2) {
                  let num = temp1[0].match(/\d+/g);
                  let letr = temp1[0].match(/[a-zA-Z]+/g);
                  openHH = num[0]
                  openMead = letr[0]
                  flag = true
                }
                else {
                  openHH = temp1[0]
                  flag = false
                }
              }
              console.log(temp1)

              if (temp1[1].includes(':')) {
                let temp = temp1[1].split(':')
                closeHH = temp[0]
                let num = temp[1].match(/\d+/g);
                let letr = temp[1].match(/[a-zA-Z]+/g);
                closeMM = num[0]
                closeMead = letr[0]

                if (!flag) {
                  openMead = closeMead
                }

              }
              else {
                closeMM = '00'
                let num = temp1[1].match(/\d+/g);
                let letr = temp1[1].match(/[a-zA-Z]+/g);
                closeHH = num[0]
                closeMead = letr[0]

                if (!flag) {
                  openMead = closeMead
                }

              }
              day = day.trim()
              if (day == 'Monday') {
                if (dayTime != 'null') {

                  this.monOpenHH = openHH
                  this.monOpenMM = openMM
                  this.monOpenMead = openMead
                  this.monCloseHH = closeHH
                  this.monCloseMM = closeMM
                  this.monCloseMead = closeMead
                  this.monPrecheck = true
                  this.mondayClearCondition = true
                }
              }
              else if (day == 'Tuesday') {
                if (temp1[1] != 'null') {
                  this.tueOpenHH = openHH
                  this.tueOpenMM = openMM
                  this.tueOpenMead = openMead
                  this.tueCloseHH = closeHH
                  this.tueCloseMM = closeMM
                  this.tueCloseMead = closeMead
                  this.tuePrecheck = true
                  this.tuesdayClearCondition = true
                }
              }
              else if (day == 'Wednesday') {
                if (temp1[1] != 'null') {
                  this.wedOpenHH = openHH
                  this.wedOpenMM = openMM
                  this.wedOpenMead = openMead
                  this.wedCloseHH = closeHH
                  this.wedCloseMM = closeMM
                  this.wedCloseMead = closeMead
                  this.wedPrecheck = true
                  this.wednesdayClearCondition = true
                }
              }
              else if (day == 'Thursday') {
                if (temp1[1] != 'null') {
                  this.thurOpenHH = openHH
                  this.thurOpenMM = openMM
                  this.thurOpenMead = openMead
                  this.thurCloseHH = closeHH
                  this.thurCloseMM = closeMM
                  this.thurCloseMead = closeMead
                  this.thurPrecheck = true
                  this.tursdayClearCondition = true

                }
              }
              else if (day == 'Friday') {
                if (temp1[1] != 'null') {
                  this.friOpenHH = openHH
                  this.friOpenMM = openMM
                  this.friOpenMead = openMead
                  this.friCloseHH = closeHH
                  this.friCloseMM = closeMM
                  this.friCloseMead = closeMead
                  this.friPrecheck = true
                  this.fridayClearCondition = true

                }
              }
              else if (day == 'Saturday') {
                if (temp1[1] != 'null') {
                  this.satOpenHH = openHH
                  this.satOpenMM = openMM
                  this.satOpenMead = openMead
                  this.satCloseHH = closeHH
                  this.satCloseMM = closeMM
                  this.satCloseMead = closeMead
                  this.satPrecheck = true
                  this.saturdayClearCondition = true

                }
              }
              else {
                if (temp1[1] != 'null') {
                  this.sunOpenHH = openHH
                  this.sunOpenMM = openMM
                  this.sunOpenMead = openMead
                  this.sunCloseHH = closeHH
                  this.sunCloseMM = closeMM
                  this.sunCloseMead = closeMead
                  this.sunPrecheck = true
                  this.sundayClearCondition = true

                }
              }
            }
          });
        }
        if (temp.special_offer) {
          let offersArr = temp.special_offer.split(',')
          offersArr.forEach(element => {
            let day = element.split(':')[0]
            let temp1 = element.split(':')
            if (day == 'Monday') {
              if (temp1[1] != 'null') {
                this.offerMonday = true
                this.offerMonValue = temp1[1]
              }
            }
            else if (day == 'Tuesday') {
              if (temp1[1] != 'null') {
                this.offerTuesday = true
                this.offerTueValue = temp1[1]
              }
            }
            else if (day == 'Wednesday') {
              if (temp1[1] != 'null') {
                this.offerWednesday = true
                this.offerWedValue = temp1[1]
              }
            }
            else if (day == 'Thursday') {
              if (temp1[1] != 'null') {
                this.offerTurusday = true
                this.offerThurValue = temp1[1]

              }
            }
            else if (day == 'Friday') {
              if (temp1[1] != 'null') {
                this.offerFriday = true
                this.offerFriValue = temp1[1]
              }
            }
            else if (day == 'Saturday') {
              if (temp1[1] != 'null') {
                this.offerSaturday = true
                this.offerSatValue = temp1[1]
              }
            }
            else {
              if (temp1[1] != 'null') {
                this.offerSunday = true
                this.offerSunValue = temp1[1]
              }
            }
          });
        }
        if (temp.appropriate_food_allergy_message) {
          if (temp.appropriate_food_allergy_message == 'A' || temp.appropriate_food_allergy_message == 'B' || temp.appropriate_food_allergy_message == 'C')
            this.queAns = temp.appropriate_food_allergy_message
          else {
            this.queAns = 'D'
            this.queAnsOtherText = temp.appropriate_food_allergy_message
          }
        }
        // if (temp.menu_name_link) {
        //   let menuNameLink = temp.menu_name_link
        //   // if (temp.menu_name_link.length > 1) menuNameLink = temp.menu_name_link[0].split(',')
        //   // else menuNameLink = temp.menu_name_link[0]
        //   console.log(menuNameLink[0].includes('.jpg'))
        //   if (menuNameLink[0].includes('.pdf') || menuNameLink.length > 1 || menuNameLink[0].includes('.png') || menuNameLink[0].includes('.jpg') || menuNameLink[0].includes('.jpeg') || menuNameLink[0].includes('.svg')) {
        //     console.log('menuNameLink[0].includes()')
        //     if (temp.menu_name) {
        //       if (temp.menu_name[0].includes('.pdf')) {
        //         this.menuPdfCondition = true
        //         this.pdfRedirctVar = temp.menu_name[0]
        //         let splitArr = temp.menu_name[0].split('/')
        //         this.pdfMenuSrc = splitArr[splitArr.length - 1]
        //         this.pdfConditionMenu = true
        //       }
        //       else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg'))) {
        //         this.menuImgCondition = true
        //         temp.menu_name.forEach(element => {
        //           this.menuSrc.push({ src: element })
        //         });
        //         this.imgConditionMenu = true
        //       }
        //     }
        //     if (temp.menu_name_link) {
        //       let menuNameLink = temp.menu_name_link
        //       if (menuNameLink[0].includes('.pdf')) {
        //         this.menuPdfCondition = true
        //         this.pdfRedirctVar = temp.menu_name[0]
        //         let splitArr = temp.menu_name[0].split('/')
        //         this.pdfMenuSrc = splitArr[splitArr.length - 1]
        //         this.pdfConditionMenu = true
        //       }
        //       else if ((menuNameLink.length > 1 || menuNameLink[0].includes('.png') || menuNameLink[0].includes('.jpg') || menuNameLink[0].includes('.jpeg') || menuNameLink[0].includes('.svg')) && typeof (menuNameLink) != 'string') {
        //         // console.log('works 2')
        //         this.menuImgCondition = true
        //         menuNameLink.forEach(element => {
        //           this.menuSrc.push({ src: element })
        //         });
        //         this.imgConditionMenu = true
        //       }
        //     }
        //   }
        //   else {
        //     this.menuLinkCondition = true
        //     this.urlLink = menuNameLink
        //   }
        // }
        // else {
        //   if (temp.menu_name) {
        //     if (temp.menu_name[0].includes('.pdf')) {
        //       this.menuPdfCondition = true
        //       this.pdfRedirctVar = temp.menu_name[0]
        //       let splitArr = temp.menu_name[0].split('/')
        //       this.pdfMenuSrc = splitArr[splitArr.length - 1]
        //       this.pdfConditionMenu = true
        //     }
        //     else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg')) && typeof (temp.menu_name) != 'string') {
        //       this.menuImgCondition = true
        //       temp.menu_name.forEach(element => {
        //         this.menuSrc.push({ src: element })
        //       });
        //       this.imgConditionMenu = true
        //     }
        //   }
        // }

        if (temp.description_and_tags) {
          this.otherDescriptionOrTags = temp.description_and_tags
        }
        if (temp.instagram_link && temp.instagram_link != 'NA' && temp.instagram_link != 'null') {
          this.instagramCon = true
          this.instagramVal = temp.instagram_link
        }
        if (temp.social_link) {
          this.facebookCon = true
          this.facebookVal = temp.social_link
        }
        if (temp.google_map_url && temp.google_map_url != 'null') {
          this.googleMapCon = true
          this.googleMapVal = temp.google_map_url
        }


      }
    })
    this.restopop = 1
  }
  openDialog(data) {
    // console.log('delete', data)
  }
  activateRestoFunc(data) {
    // console.log('activate', data)
  }
  closeResto() {
    this.restopop = 0
    this.selectedDieatry = []
    this.selectedAllegens = []
    this.selectedCaategory = []
    this.selectedCuisine = []
    this.restoName = ''
    this.restoEmail = ''
    this.restoAddress = ''
    this.restoDescrip = ''
    this.restoPhone = ''
    this.restoLogitude = ''
    this.restoLotitude = ''
    this.restoMapLink = ''
    this.offerValue = ''
    this.restoStreetName = ''
    this.restoCity = ''
    this.restoAvgRating = ''
    this.src = "../../../assets/images/Ellipse 11.png";
    this.featureSrc = '../../../assets/images/Ellipse 11.png'
    this.menuPdfCondition = false
    this.pdfConditionMenu = false
    this.pdfMenuSrc = 'null'
    this.menuImgCondition = false
    this.menuSrc = []
    this.imgConditionMenu = false
    this.currentRestoId = null
    this.sendData.forEach((val, key) => {
      this.sendData.delete(key)
    });
    this.logoToBeAppend = null
    this.featureImgToBeAppend = null
    this.menuImgToBeAppend = []
    this.menuPdfToBeAppend = null
    this.sendData = new FormData()
    this.monOpenHH = ''
    this.monOpenMM = ''
    this.monOpenMead = 'am'
    this.monPrecheck
    this.monCloseHH = ''
    this.monCloseMM = ''
    this.monCloseMead = 'am'
    this.tueOpenHH = ''
    this.tueOpenMM = ''
    this.tueOpenMead = 'am'
    this.tueCloseHH = ''
    this.tueCloseMM = ''
    this.tueCloseMead = 'am'
    this.tuePrecheck
    this.wedOpenHH = ''
    this.wedOpenMM = ''
    this.wedOpenMead = 'am'
    this.wedCloseHH = ''
    this.wedCloseMM = ''
    this.wedCloseMead = 'am'
    this.wedPrecheck
    this.thurOpenHH = ''
    this.thurOpenMM = ''
    this.thurOpenMead = 'am'
    this.thurCloseHH = ''
    this.thurCloseMM = ''
    this.thurCloseMead = 'am'
    this.thurPrecheck
    this.friOpenHH = ''
    this.friOpenMM = ''
    this.friOpenMead = 'am'
    this.friCloseHH = ''
    this.friCloseMM = ''
    this.friCloseMead = 'am'
    this.friPrecheck
    this.satOpenHH = ''
    this.satOpenMM = ''
    this.satOpenMead = 'am'
    this.satCloseHH = ''
    this.satCloseMM = ''
    this.satCloseMead = 'am'
    this.satPrecheck
    this.sunOpenHH = ''
    this.sunOpenMM = ''
    this.sunOpenMead = 'am'
    this.sunCloseHH = ''
    this.sunCloseMM = ''
    this.sunCloseMead = 'am'
    this.sunPrecheck
    this.mondayClearCondition = false
    this.tuesdayClearCondition = false
    this.wednesdayClearCondition = false
    this.tursdayClearCondition = false
    this.fridayClearCondition = false
    this.saturdayClearCondition = false
    this.sundayClearCondition = false

    this.offerMonday = false
    this.offerTuesday = false
    this.offerWednesday = false
    this.offerTurusday = false
    this.offerFriday = false
    this.offerSaturday = false
    this.offerSunday = false
    this.offerMonValue = ''
    this.offerTueValue = ''
    this.offerWedValue = ''
    this.offerThurValue = ''
    this.offerFriValue = ''
    this.offerSatValue = ''
    this.offerSunValue = ''

    this.queAns = ''
    this.queAnsOtherText = ''
    this.menuSrc = []
    // this.menuPdfCondition
    // this.menuImgCondition
    this.pdfConditionMenu = false
    this.imgConditionMenu = false
    this.menuLinkCondition = false
    this.menuImgToBeAppend = []
    this.menuPdfToBeAppend = null
    this.pdfMenuSrc = 'null'
    this.pdfRedirctVar = null

    this.delverooCon = false
    this.justEatCon = false
    this.uberEatsCon = false
    this.foodstuffCon = false
    this.delverooVal = null
    this.justEatVal = null
    this.uberEatsVal = null
    this.foodstuffVal = null

    this.instagramCon = false
    this.facebookCon = false
    this.googleMapCon = false
    this.instagramVal = null
    this.facebookVal = null
    this.googleMapVal = null
    this.otherDescriptionOrTags = ''
    this.getAllResto()
  }
  submitRestoCreate() {
    this.sendData.append('restaurant_id', this.currentRestoId)
    this.sendData.append('restaurant_name', this.restoName)
    this.sendData.append('restaurant_email', this.restoEmail)
    this.sendData.append('restaurant_address', this.restoAddress)
    console.log(this.restoAddress);

    this.sendData.append('description', this.restoDescrip)
    this.sendData.append('contact_no', this.restoPhone)
    this.sendData.append('longitude', this.restoLogitude)
    this.sendData.append('latitude', this.restoLotitude)
    this.sendData.append('google_map_url', this.restoMapLink)
    this.sendData.append('special_offer', this.offerValue)
    this.sendData.append('street_name', this.restoStreetName)
    this.sendData.append('city', this.restoCity)
    this.sendData.append('dietary_preferences', this.selectedDieatry)
    this.sendData.append('allergens', this.selectedAllegens)
    this.sendData.append('categories', this.selectedCaategory)
    this.sendData.append('cuisine', this.selectedCuisine)
    this.sendData.append('foodbud_menu_available', this.foodbudMenu)
    this.sendData.append('trusted', this.trusted)

    if (this.logoToBeAppend) this.sendData.append("logo", this.logoToBeAppend);
    if (this.featureImgToBeAppend) this.sendData.append("featured_image", this.featureImgToBeAppend);
    // if (this.menuImgToBeAppend.length != 0) {
    //   this.menuImgToBeAppend.forEach(element => {
    //     this.sendData.append("menu_name[]", element)
    //   })
    // }
    // if (this.menuPdfToBeAppend) this.sendData.append("menu_name[]", this.menuPdfToBeAppend);
    let mon
    let tue
    let wed
    let thur
    let fri
    let sat
    let sun
    let time = ''
    if (this.monPrecheck) {
      mon = this.monPrecheck ? "Monday:" + '[' + this.monOpenHH + ":" + this.monOpenMM + this.monOpenMead + '-' + this.monCloseHH + ':' + this.monCloseMM + this.monCloseMead + ']' : "Monday:null"
      time = time.concat(mon)
    }

    if (this.tuePrecheck) {
      tue = this.tuePrecheck ? `Tuesday:[${this.tueOpenHH}:${this.tueOpenMM}${this.tueOpenMead}-${this.tueCloseHH}:${this.tueCloseMM}${this.tueCloseMead}]` : 'Tuesday:null'
      if (time.length > 2) {
        time = time.concat(',')
        time = time.concat(tue)
      }
      else time = time.concat(tue)
    }
    if (this.wedPrecheck) {
      wed = this.wedPrecheck ? `Wednesday:[${this.wedOpenHH}:${this.wedOpenMM}${this.wedOpenMead}-${this.wedCloseHH}:${this.wedCloseMM}${this.wedCloseMead}]` : 'Wednesday:null'
      if (time.length > 2) {
        time = time.concat(',')
        time = time.concat(wed)
      }
      else time = time.concat(wed)
    }
    if (this.thurPrecheck) {
      thur = this.thurPrecheck ? `Thursday:[${this.thurOpenHH}:${this.thurOpenMM}${this.thurOpenMead}-${this.thurCloseHH}:${this.thurCloseMM}${this.thurCloseMead}]` : 'Thursday:null'
      if (time.length > 2) {
        time = time.concat(',')
        time = time.concat(thur)
      }
      else time = time.concat(thur)
    }
    if (this.friPrecheck) {
      fri = this.friPrecheck ? `Friday:[${this.friOpenHH}:${this.friOpenMM}${this.friOpenMead}-${this.friCloseHH}:${this.friCloseMM}${this.friCloseMead}]` : 'Friday:null'
      if (time.length > 2) {
        time = time.concat(',')
        time = time.concat(fri)
      }
      else time = time.concat(fri)
    }
    if (this.satPrecheck) {
      sat = this.satPrecheck ? `Saturday:[${this.satOpenHH}:${this.satOpenMM}${this.satOpenMead}-${this.satCloseHH}:${this.satCloseMM}${this.satCloseMead}]` : 'Saturday:null'
      if (time.length > 2) {
        time = time.concat(',')
        time = time.concat(sat)
      }
      else time = time.concat(sat)
    }
    if (this.sunPrecheck) {
      sun = this.sunPrecheck ? `Sunday:[${this.sunOpenHH}:${this.sunOpenMM}${this.sunOpenMead}-${this.sunCloseHH}:${this.sunCloseMM}${this.sunCloseMead}]` : 'Sunday:null'
      if (time.length > 2) {
        time = time.concat(',')
        time = time.concat(sun)
      }
      else time = time.concat(sun)
    }
    //  = `${mon},${tue},${wed},${thur},${fri},${sat},${sun}`
    this.sendData.append('opening_hours', time)
    console.log(time);

    let monOffer = this.offerMonday ? "Monday:" + this.offerMonValue : "Monday:null"
    let tueOffer = this.offerTuesday ? "Tuesday:" + this.offerTueValue : "Tuesday:null"
    let wedOffer = this.offerWednesday ? "Wednesday:" + this.offerWedValue : "Wednesday:null"
    let thurOffer = this.offerTurusday ? "Thursday:" + this.offerThurValue : "Thursday:null"
    let friOffer = this.offerFriday ? "Friday:" + this.offerFriValue : "Friday:null"
    let satOffer = this.offerSaturday ? "Saturday:" + this.offerSatValue : "Saturday:null"
    let sunOffer = this.offerSunday ? "Sunday:" + this.offerSunValue : "Sunday:null"
    let finalOffer = `${monOffer},${tueOffer},${wedOffer},${thurOffer},${friOffer},${satOffer},${sunOffer}`
    this.sendData.append('special_offer', finalOffer)
    if (this.queAns && this.queAns != 'D') this.sendData.append('appropriate_food_allergy_message', this.queAns)
    else if (this.queAns && this.queAns == 'D') this.sendData.append('appropriate_food_allergy_message', this.queAnsOtherText)
    if (this.menuLinkCondition) {
      console.log('link-inside')
      this.sendData.append('menu_name_link[]', this.urlLink)
    } else {

      if (this.pdfRedirctVar) {
        if (this.menuPdfToBeAppend) {
          console.log('pdfCheck1')
          this.sendData.append('menu_name[]', this.menuPdfToBeAppend)
        }
        else {
          console.log('pdfCheck2')
          this.sendData.append('menu_name_link[]', this.pdfMenuSrc)
        }
      }
      else {
        let link: any = []
        if (this.menuSrc.length == this.menuImgToBeAppend.length) {
          this.menuImgToBeAppend.forEach(ele => {
            this.sendData.append('menu_name[]', ele)
          })
        }
        else {
          if (this.menuImgToBeAppend.length > 0) {
            this.menuImgToBeAppend.forEach(ele => {
              this.sendData.append('menu_name[]', ele)
            })
          }
          this.menuSrc.forEach(ele => {
            // if (ele.src.includes('http')) this.sendData.append('menu_name_link[]', ele.src)
            if (ele.src.includes('http')) link.push(ele.src)
          })
          this.sendData.append('menu_name_link[]', link)
        }
      }
    }
    let deleviroo = this.delverooCon ? 'Deliveroo:' + this.delverooVal : 'Deliveroo:null'
    let justeat = this.justEatCon ? 'JustEat:' + this.justEatVal : 'JustEat:null'
    let ubereat = this.uberEatsCon ? 'UberEats:' + this.uberEatsVal : 'UberEats:null'
    let foodstuf = this.foodstuffCon ? 'Foodstuff:' + this.foodstuffVal : 'Foodstuff:null'
    let deleveryPartner = `${deleviroo},${justeat},${ubereat},${foodstuf}`
    this.sendData.append('delivery_partner', deleveryPartner)
    if (this.instagramCon) this.sendData.append('instagram_link', this.instagramVal)
    else this.sendData.append('instagram_link', null)
    if (this.facebookCon) this.sendData.append('social_link', this.facebookVal)
    if (this.googleMapCon) this.sendData.append('google_map_url', this.googleMapVal)
    else this.sendData.append('google_map_url', null)
    if (this.otherDescriptionOrTags.length > 0) this.sendData.append('description_and_tags', this.otherDescriptionOrTags)


    this.httpSv.updateD2Restaurant(this.sendData).subscribe(res => {
      if (res['status'] == true) {
        this._snackBar.open('Restaurant Updated')
        this.closeResto()
        setTimeout(() => {
          this._snackBar.dismiss()
        }, 2000)

      } else {
        this._snackBar.open(res['message'])
        setTimeout(() => {
          this._snackBar.dismiss()
        }, 2000)
      }
    }, err => {
      this._snackBar.open('Opps! Something went wrong')
      setTimeout(() => {
        this._snackBar.dismiss()
      }, 2000)
    })
  }

  // for dietary prefrance
  onMaterialGroupChange(event) {
    // console.log(event);
  }

  getData() {
    let temp
    this.httpSv.getAllD2Dieatry().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allDieatary = temp
      }
    })
    return (this.allDieatary = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  getAllergens() {
    let temp
    this.httpSv.getAllD2DAllergen().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allAllergens = temp
      }
    })
    return (this.allAllergens = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  getCategory() {
    let temp
    this.httpSv.getAllD2Category().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allCaategory = temp
      }
    })
    return (this.allCaategory = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  getCuisine() {
    let temp
    this.httpSv.getAllD2Cuisine().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allCuisine = temp
      }
    })
    return (this.allCuisine = [
      { id: 1, name: 'Undefine' }
    ]);
  }

  selectAllForDropdownItems(items: any[]) {
    let allSelect = (items) => {
      items.forEach((element) => {
        element['selectedAllGroup'] = 'selectedAllGroup';
      });
    };

    allSelect(items);
  }
  onFeatureImgChange(event, id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    if (fileSize > 500) {
      this._snackBar.open(`Image can't be uploaded, as the size is bigger than 500 kb`)
      setTimeout(() => { this._snackBar.dismiss() }, 3000)
      document.getElementById(id)['value'] = ''
      // alert(`Sorry this is can't be uploaded .The image size is greater than 500kb`)
      return
    }
    this.featureImgToBeAppend = event.target.files[0]
    let file: File = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.src = e.target.result;
      document.getElementById(id)['value'] = ''
    };
  }
  imgUploadChechFunc(data) {
    if (this.pdfMenuSrc == 'null') {
      data.click()
    }
    else {
      let con = confirm('Are you sure to upload the image , this will delete the pdf file')
      if (con) {
        this.pdfMenuSrc = 'null'
        this.menuPdfToBeAppend = null
        data.click()
      }
    }
  }
  // onMenuChange(event) {
  //   for (let i = 0; i < event.target.files.length; i++) {
  //     this.menuImgToBeAppend.push(event.target.files[i])

  //     let reader: FileReader = new FileReader();
  //     reader.readAsDataURL(event.target.files[i]);
  //     reader.onloadend = (e: any) => {
  //       this.menuSrc.push({ src: e.target.result, name: event.target.files[i].name })
  //     };
  //   }
  // }
  // pdfUploadCheckFunc(data) {
  //   if (this.menuSrc.length == 0) {
  //     data.click()
  //   }
  //   else {
  //     let con = confirm('Are you sure to upload the pdf , this will delete the images')
  //     if (con) {
  //       this.menuSrc = []
  //       this.menuImgToBeAppend = []
  //       data.click()
  //     }
  //   }
  // }

  // onMenuPdfChange(event) {
  //   this.menuPdfToBeAppend = event.target.files[0]
  //   this.pdfMenuSrc = event.target.files[0].name
  //   let reader: FileReader = new FileReader();
  //   reader.readAsDataURL(event.target.files[0]);
  //   reader.onload = (e: any) => {
  //     this.pdfRedirctVar = e.target.result
  //   };

  // }
  pdfConditionMenu: boolean = false
  imgConditionMenu: boolean = false
  pdfOrImagefunc(data) {
    if (data == 'pdf') {
      this.pdfConditionMenu = true
      this.imgConditionMenu = false
    }
    else {
      this.imgConditionMenu = true
      this.pdfConditionMenu = false
    }
  }
  getAllResto() {
    this.httpSv.getAllCsvResto().subscribe(res => {
      if (res['status'] == "TRUE") {
        this.restaurantList = res["result"].data;
        this.dataSource.data = res["result"].data;
        this.dataSource.paginator = this.paginator;
      }
    })
  }
  openpdf() {
    window.open(this.pdfRedirctVar)
  }
  openImgFunc(src) {
    // console.log(src)
    window.open(src.toString())
  }
  foodBudMenuFunc(data) {
    if (data) {
      this.foodMenuAvalaible = 'Yes'
    } else {
      this.foodMenuAvalaible = 'No'
    }
  }
  trustedFunc(data) {
    if (data) {
      this.trusted = 'Yes'
    } else {
      this.trusted = 'No'
    }
  }
  deleteImg(data) {
    if (data.src.includes('base64')) {
      let indexMenuSrc = this.menuSrc.findIndex(ele => {
        return ele.name == data.name
      })
      this.menuSrc.splice(indexMenuSrc, 1)
      let indexMenuAppend = this.menuImgToBeAppend.findIndex(ele => {
        return ele.name == data.name
      })
      this.menuImgToBeAppend.splice(indexMenuAppend, 1)
    }
  }
  pdfDelete() {
    if (this.menuImgToBeAppend) {
      this.pdfMenuSrc = 'null'
      this.menuPdfToBeAppend = null
    }
  }
  timeInputFunc(day, e) {

    if (e.checked) {
      if (day == 'mondayTime') {
        this.mondayClearCondition = true
        this.monPrecheck = true
      }
      else if (day == 'tuesdayTime') {
        this.tuesdayClearCondition = true
        this.tuePrecheck = true
      }
      else if (day == 'wednesTime') {
        this.wednesdayClearCondition = true
        this.wedPrecheck = true
      }
      else if (day == 'thursdayTime') {
        this.tursdayClearCondition = true
        this.thurPrecheck = true
      }
      else if (day == 'fridayTime') {
        this.fridayClearCondition = true
        this.friPrecheck = true
      }
      else if (day == 'saturdayTime') {
        this.saturdayClearCondition = true
        this.satPrecheck = true
      }
      else if (day == 'sundayTime') {
        this.sundayClearCondition = true
        this.sunPrecheck = true
      }
    }
    else {
      if (day == 'mondayTime') {
        this.timeClear(day)
        this.mondayClearCondition = false
        this.monPrecheck = false
      }
      else if (day == 'tuesdayTime') {
        this.timeClear(day)
        this.tuesdayClearCondition = false
        this.tuePrecheck = false
      }
      else if (day == 'wednesTime') {
        this.timeClear(day)
        this.wednesdayClearCondition = false
        this.wedPrecheck = false
      }
      else if (day == 'thursdayTime') {
        this.timeClear(day)
        this.tursdayClearCondition = false
        this.thurPrecheck = false
      }
      else if (day == 'fridayTime') {
        this.timeClear(day)
        this.fridayClearCondition = false
        this.friPrecheck = false
      }
      else if (day == 'saturdayTime') {
        this.timeClear(day)
        this.saturdayClearCondition = false
        this.satPrecheck = false
      }
      else if (day == 'sundayTime') {
        this.timeClear(day)
        this.sundayClearCondition = false
        this.sunPrecheck = false
      }
    }

    // console.log(this.tuePrecheck, this.monOpenHH, this.monOpenMM, this.monCloseHH, this.monCloseMM)
  }
  timeClear(id) {
    if (id == 'mondayTime') {
      this.monOpenHH = ''
      this.monOpenMM = ''
      this.monOpenMead = 'am'
      this.monCloseHH = ''
      this.monCloseMM = ''
      this.monCloseMead = 'am'
    }
    else if (id == 'tuesdayTime') {
      this.tueOpenHH = ''
      this.tueOpenMM = ''
      this.tueOpenMead = 'am'
      this.tueCloseHH = ''
      this.tueCloseMM = ''
      this.tueCloseMead = 'am'
    }
    else if (id == 'wednesTime') {
      this.wedOpenHH = ''
      this.wedOpenMM = ''
      this.wedOpenMead = 'am'
      this.wedCloseHH = ''
      this.wedCloseMM = ''
      this.wedCloseMead = 'am'
    }
    else if (id == 'thursdayTime') {
      this.thurOpenHH = ''
      this.thurOpenMM = ''
      this.thurOpenMead = 'am'
      this.thurCloseHH = ''
      this.thurCloseMM = ''
      this.thurCloseMead = 'am'
    }
    else if (id == "fridayTime") {
      this.friOpenHH = ''
      this.friOpenMM = ''
      this.friOpenMead = 'am'
      this.friCloseHH = ''
      this.friCloseMM = ''
      this.friCloseMead = 'am'
    }
    else if (id == 'saturdayTime') {
      this.satOpenHH = ''
      this.satOpenMM = ''
      this.satOpenMead = 'am'
      this.satCloseHH = ''
      this.satCloseMM = ''
      this.satCloseMead = 'am'
    }
    else if (id == 'sundayTime') {
      this.sunOpenHH = ''
      this.sunOpenMM = ''
      this.sunOpenMead = 'am'
      this.sunCloseHH = ''
      this.sunCloseMM = ''
      this.sunCloseMead = 'am'
    }
  }
  copyTimeFunc(day) {
    if (day == 'tue') {
      this.tueOpenHH = this.monOpenHH
      this.tueOpenMM = this.monOpenMM
      this.tueOpenMead = this.monOpenMead
      this.tueCloseHH = this.monCloseHH
      this.tueCloseMM = this.monCloseMM
      this.tueCloseMead = this.monCloseMead

    }
    else if (day == 'wed') {
      this.wedOpenHH = this.tueOpenHH
      this.wedOpenMM = this.tueOpenMM
      this.wedOpenMead = this.tueOpenMead
      this.wedCloseHH = this.tueCloseHH
      this.wedCloseMM = this.tueCloseMM
      this.wedCloseMead = this.tueCloseMead
    }
    else if (day == 'thur') {
      this.thurOpenHH = this.wedOpenHH
      this.thurOpenMM = this.wedOpenMM
      this.thurOpenMead = this.wedOpenMead
      this.thurCloseHH = this.wedCloseHH
      this.thurCloseMM = this.wedCloseMM
      this.thurCloseMead = this.wedCloseMead
    }
    else if (day == 'fri') {
      this.friOpenHH = this.thurOpenHH
      this.friOpenMM = this.thurOpenMM
      this.friOpenMead = this.thurOpenMead
      this.friCloseHH = this.thurCloseHH
      this.friCloseMM = this.thurCloseMM
      this.friCloseMead = this.thurCloseMead
    }
    else if (day == 'sat') {
      this.satOpenHH = this.friOpenHH
      this.satOpenMM = this.friOpenMM
      this.satOpenMead = this.friOpenMead
      this.satCloseHH = this.friCloseHH
      this.satCloseMM = this.friCloseMM
      this.satCloseMead = this.friCloseMead
    }
    else if (day == 'sun') {
      this.sunOpenHH = this.satOpenHH
      this.sunOpenMM = this.satOpenMM
      this.sunOpenMead = this.satOpenMead
      this.sunCloseHH = this.satCloseHH
      this.sunCloseMM = this.satCloseMM
      this.sunCloseMead = this.satCloseMead
    }

  }
  offerHandelFunc(day, e) {
    if (e.checked) {
      if (day == 'mon') {
        this.offerMonday = true
      }
      else if (day == 'tue') {
        this.offerTuesday = true
      }
      else if (day == 'wed') {
        this.offerWednesday = true
      }
      else if (day == 'thu') {
        this.offerTurusday = true
      }
      else if (day == 'fri') {
        this.offerFriday = true
      }
      else if (day == 'sat') {
        this.offerSaturday = true
      }
      else if (day == 'sun') {
        this.offerSunday = true
      }
    }
    else {
      if (day == 'mon') {
        this.offerMonday = false
      }
      else if (day == 'tue') {
        this.offerTuesday = false
      }
      else if (day == 'wed') {
        this.offerWednesday = false
      }
      else if (day == 'thu') {
        this.offerTurusday = false
      }
      else if (day == 'fri') {
        this.offerFriday = false
      }
      else if (day == 'sat') {
        this.offerSaturday = false
      }
      else if (day == 'sun') {
        this.offerSunday = false
      }

    }
  }
  preRadioSelect(option) {
    if (option == this.queAns) return true
    else false
  }
  menuImgDelete(index, src) {
    if (src.src.includes('base64')) {
      let reqIndex = this.menuImgToBeAppend.findIndex(ele => ele.name == src.name)
      this.menuSrc.splice(index, 1)
      this.menuImgToBeAppend.splice(reqIndex, 1)
    }
    else {
      this.menuSrc.splice(index, 1)
    }
  }
  onMenuChange(event, id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    if (fileSize > 500) {
      this._snackBar.open(`Image can't be uploaded, as the size is bigger than 500 kb`)
      setTimeout(() => { this._snackBar.dismiss() }, 3000)
      document.getElementById(id)['value'] = ''
      // alert(`Sorry this is can't be uploaded .The image size is greater than 500kb`)
      return
    }
    this.menuLinkCondition = false
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      let temp = event.target.files[0].name.split('.')
      if (temp[temp.length - 1] != 'pdf') {
        this.menuImgToBeAppend.push(event.target.files[0])
        this.menuPdfToBeAppend = null
        this.menuSrc.push({ src: e.target.result, name: event.target.files[0].name })
        document.getElementById(id)['value'] = ''
      }
      else {
        this.pdfUploadCheckFunc(event, id)
      }
    }
  }
  pdfUploadCheckFunc(data, id) {
    if (this.menuSrc.length != 0) {
      let con = confirm('Are you sure to upload the pdf , this will delete the images')
      if (con) {
        this.menuSrc = []
        this.menuImgToBeAppend = []
        this.onMenuPdfChange(data, id)

      }
      else {
        document.getElementById(id)['value'] = ''
      }
    }
    else {
      this.onMenuPdfChange(data, id)
    }
  }
  onMenuPdfChange(event, id) {
    this.menuPdfToBeAppend = event.target.files[0]
    this.pdfMenuSrc = event.target.files[0].name
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.pdfRedirctVar = e.target.result
      document.getElementById(id)['value'] = ''
      this.menuSrc = []
      this.menuImgToBeAppend = []
    };

  }
  menuLinkInsert() {
    this.menuLinkCondition = true
  }
  delverooCon = false
  justEatCon = false
  uberEatsCon = false
  foodstuffCon = false
  delverooVal
  justEatVal
  uberEatsVal
  foodstuffVal
  delevryHandelFunc(name, event) {
    if (event.checked) {
      if (name == 'deliveroo') this.delverooCon = true
      else if (name == 'justEat') this.justEatCon = true
      else if (name == 'uberEats') this.uberEatsCon = true
      else if (name == 'foodstuff') this.foodstuffCon = true
    }
    else {
      if (name == 'deliveroo') this.delverooCon = false
      else if (name == 'justEat') this.justEatCon = false
      else if (name == 'uberEats') this.uberEatsCon = false
      else if (name == 'foodstuff') this.foodstuffCon = false
    }
  }
  instagramCon = false
  facebookCon = false
  googleMapCon = false
  instagramVal
  facebookVal
  googleMapVal
  socialLinkHandelFunc(name, event) {
    if (event.checked) {
      if (name == 'facebook') this.facebookCon = true
      else if (name == 'instagram') this.instagramCon = true
      else if (name == 'googleMap') this.googleMapCon = true
    }
    else {
      if (name == 'facebook') this.facebookCon = false
      else if (name == 'instagram') this.instagramCon = false
      else if (name == 'googleMap') this.googleMapCon = false
    }
  }
  validate(event) {
    let k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k >= 48 && k <= 57));
  }
  statusHandleFunc(event, id) {
    if (event.checked) {
      let data = {
        "restaurant_id": id,
        "restaurant_status": "Active"
      }
      this.httpSv.updateCsvRestoStatus(data).subscribe(res => {
        if (res['status'] == 'TRUE') {
          this._snackBar.open('Restaurant is active now!!')
          this.getAllResto()
          setTimeout(() => {
            this._snackBar.dismiss()
          }, 2000)
        } else {
          this._snackBar.open(res['message'])
          setTimeout(() => {
            this._snackBar.dismiss()
          }, 2000)
        }
      }, err => {
        this._snackBar.open('Oops!! Something went wrong')
        setTimeout(() => {
          this._snackBar.dismiss()
        }, 2000)
      })
    }
    else {
      let data = {
        "restaurant_id": id,
        "restaurant_status": "Inactive"
      }
      this.httpSv.updateCsvRestoStatus(data).subscribe(res => {
        if (res['status'] == 'TRUE') {
          this._snackBar.open('Restaurant is inactive now!!')
          this.getAllResto()
          setTimeout(() => {
            this._snackBar.dismiss()
          }, 2000)
        } else {
          this._snackBar.open(res['message'])
          setTimeout(() => {
            this._snackBar.dismiss()
          }, 2000)
        }
      }, err => {
        this._snackBar.open('Oops!! Something went wrong')
        setTimeout(() => {
          this._snackBar.dismiss()
        }, 2000)
      })
    }
  }
  validateNum(event) {
    let k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k >= 48 && k <= 57) || k == 43 || k == 32);
  }
}
// ---------------------------------------------------------------------------------------------------------------------------
// -------------------------------------------------------------------------------------------------------------------------
// ----------------------------------------------------------------------------------------------------------------------------

@Component({
  selector: 'app-claimed-resto',
  templateUrl: './claimedResto.html',
  styleUrls: ['./d2-all-resto.component.scss']
})
export class ClaimedRestoComponent implements OnInit {
  constructor(private httpSv: HttpService, private cdRef: ChangeDetectorRef, private _snackBar: MatSnackBar, private dialog: MatDialog) {

  }
  @ViewChild(MatPaginator) paginator1: MatPaginator;
  ngOnInit(): void {
    this.getAllergens()
    this.getData()
    this.getCuisine()
    this.getCategory()
    this.getAllResto()
  }
  monOpenHH = ''
  monOpenMM = ''
  monOpenMead = 'am'
  monPrecheck
  monCloseHH = ''
  monCloseMM = ''
  monCloseMead = 'am'
  tueOpenHH = ''
  tueOpenMM = ''
  tueOpenMead = 'am'
  tueCloseHH = ''
  tueCloseMM = ''
  tueCloseMead = 'am'
  tuePrecheck
  wedOpenHH = ''
  wedOpenMM = ''
  wedOpenMead = 'am'
  wedCloseHH = ''
  wedCloseMM = ''
  wedCloseMead = 'am'
  wedPrecheck
  thurOpenHH = ''
  thurOpenMM = ''
  thurOpenMead = 'am'
  thurCloseHH = ''
  thurCloseMM = ''
  thurCloseMead = 'am'
  thurPrecheck
  friOpenHH = ''
  friOpenMM = ''
  friOpenMead = 'am'
  friCloseHH = ''
  friCloseMM = ''
  friCloseMead = 'am'
  friPrecheck
  satOpenHH = ''
  satOpenMM = ''
  satOpenMead = 'am'
  satCloseHH = ''
  satCloseMM = ''
  satCloseMead = 'am'
  satPrecheck
  sunOpenHH = ''
  sunOpenMM = ''
  sunOpenMead = 'am'
  sunCloseHH = ''
  sunCloseMM = ''
  sunCloseMead = 'am'
  sunPrecheck

  oldmonOpenHH = ''
  oldmonOpenMM = ''
  oldmonOpenMead = 'am'
  oldmonPrecheck
  oldmonCloseHH = ''
  oldmonCloseMM = ''
  oldmonCloseMead = 'am'
  oldtueOpenHH = ''
  oldtueOpenMM = ''
  oldtueOpenMead = 'am'
  oldtueCloseHH = ''
  oldtueCloseMM = ''
  oldtueCloseMead = 'am'
  oldtuePrecheck
  oldwedOpenHH = ''
  oldwedOpenMM = ''
  oldwedOpenMead = 'am'
  oldwedCloseHH = ''
  oldwedCloseMM = ''
  oldwedCloseMead = 'am'
  oldwedPrecheck
  oldthurOpenHH = ''
  oldthurOpenMM = ''
  oldthurOpenMead = 'am'
  oldthurCloseHH = ''
  oldthurCloseMM = ''
  oldthurCloseMead = 'am'
  oldthurPrecheck
  oldfriOpenHH = ''
  oldfriOpenMM = ''
  oldfriOpenMead = 'am'
  oldfriCloseHH = ''
  oldfriCloseMM = ''
  oldfriCloseMead = 'am'
  oldfriPrecheck
  oldsatOpenHH = ''
  oldsatOpenMM = ''
  oldsatOpenMead = 'am'
  oldsatCloseHH = ''
  oldsatCloseMM = ''
  oldsatCloseMead = 'am'
  oldsatPrecheck
  oldsunOpenHH = ''
  oldsunOpenMM = ''
  oldsunOpenMead = 'am'
  oldsunCloseHH = ''
  oldsunCloseMM = ''
  oldsunCloseMead = 'am'
  oldsunPrecheck


  offerMonday = false
  offerTuesday = false
  offerWednesday = false
  offerTurusday = false
  offerFriday = false
  offerSaturday = false
  offerSunday = false
  offerMonValue = ''
  offerTueValue = ''
  offerWedValue = ''
  offerThurValue = ''
  offerFriValue = ''
  offerSatValue = ''
  offerSunValue = ''

  offerOldMonday = false
  offerOldTuesday = false
  offerOldWednesday = false
  offerOldTurusday = false
  offerOldFriday = false
  offerOldSaturday = false
  offerOldSunday = false
  offerOldMonValue = ''
  offerOldTueValue = ''
  offerOldWedValue = ''
  offerOldThurValue = ''
  offerOldFriValue = ''
  offerOldSatValue = ''
  offerOldSunValue = ''

  src: string = "../../../assets/images/Ellipse 11.png";
  NewSrc: string = "../../../assets/images/Ellipse 11.png";
  featureSrc: string = "../../../assets/images/Ellipse 11.png";
  newfeatureSrc: string = "../../../assets/images/Ellipse 11.png";
  logoToBeAppend: any = null
  featureImgToBeAppend: any = null
  menuSrc: any[] = []
  newmenuSrc: any[] = []
  menuPdfCondition
  menuImgCondition
  pdfConditionMenu: boolean = false
  imgConditionMenu: boolean = false
  menuLinkCondition = false
  urlLink = ''
  menuLinkConditionNew = false
  urlLinkNew = ''
  menuImgToBeAppend: any[] = []
  menuPdfToBeAppend: any = null
  pdfMenuSrc = 'null'
  newpdfMenuSrc = 'null'
  pdfRedirctVar: any = null
  newpdfRedirctVar: any = null
  stringOldMenu: string
  stringNewMenu: string
  stringNewPdfSrc: string
  stringOldPdfSrc: string
  otherDescriptionOrTags = ''
  otherDescriptionOrTagsNew = ''
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator1;
  }
  allDieatary = [];
  allAllergens = []
  allCaategory = []
  allCuisine = []
  selectedCityIds: string[];
  selectedDieatry = []
  selectedAllegens = []
  selectedCaategory = []
  selectedCuisine = []
  restofound = false
  restopop: number = 0
  searchText = ''
  allRestaurantList: any[] = []
  restaurantList: any[] = []
  displayedColumns: string[] = [
    "id",
    "name",
    "email",
    // "level",
    "info",
    "action"
    // "status",
  ];


  l1_waiting = true;
  l1_approved = false;
  l2 = false;
  l3 = false;


  l1_waiting_all_resto = []
  l1_approved_all_resto = []
  l2_all_resto = []
  l3_all_resto = []


  l1WaitingRestoList() {
    if (this.l1_waiting == true) {
      return
    }
    this.l1_waiting = true;
    this.l1_approved = false;
    this.l2 = false;
    this.l3 = false;
    this.restaurantList = this.l1_waiting_all_resto
    this.noResto = this.restaurantList.length
    this.filter()
  }
  l1ApprovedRestoList() {
    if (this.l1_approved == true) {
      return
    }
    this.l1_waiting = false;
    this.l1_approved = true;
    this.l2 = false;
    this.l3 = false;
    this.restaurantList = this.l1_approved_all_resto
    this.noResto = this.restaurantList.length
    this.filter()
  }
  l2RestoList() {
    if (this.l2 == true) {
      return
    }
    this.l1_waiting = false;
    this.l1_approved = false;
    this.l2 = true;
    this.l3 = false;
    this.restaurantList = this.l2_all_resto
    this.noResto = this.restaurantList.length
    this.filter()
  }
  l3RestoList() {
    if (this.l3 == true) {
      return
    }
    this.l1_waiting = false;
    this.l1_approved = false;
    this.l2 = false;
    this.l3 = true;
    this.restaurantList = this.l3_all_resto
    this.noResto = this.restaurantList.length
    this.filter()
  }




  dataSource: MatTableDataSource<[]> = new MatTableDataSource(
    this.restaurantList
  );
  restoName = ''
  restoNewName = ''
  restoEmail = ''
  restoNewEmail = ''
  restoWebsite = ''
  restoNewWebsite = ''
  restoPhone = ''
  restoNewPhone = ''
  restoDescription = ''
  restoNewDescription = ''
  restoNewDescrip = ''
  restoAddress = ''
  restoNewAddress = ''
  restoAvgRating = ''
  restoNewAvgRating = ''
  selectedNewCuisine = []
  selectedNewCategories = []
  selectedNewDietaer = []
  selectedNewAllergens = []

  stringSelectedCuisine: string
  stringSelectedNewCuisine: string
  stringSelectedCategory: string
  stringSelectedNewCategory: string
  stringSelectedDiet: string
  stringSelectedNewDiet: string
  stringSelctedAllegens: string
  stringSelctedNewAllegens: string
  approAns
  approOldAns
  queAnsOtherTextNew = ''
  queAnsOtherText = ''
  onMaterialGroupChange(event) {
    // console.log(event);
  }
  getData() {
    let temp
    this.httpSv.getAllD2Dieatry().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allDieatary = temp
      }
    })
    return (this.allDieatary = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  getAllergens() {
    let temp
    this.httpSv.getAllD2DAllergen().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allAllergens = temp
      }
    })
    return (this.allAllergens = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  getCategory() {
    let temp
    this.httpSv.getAllD2Category().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allCaategory = temp
      }
    })
    return (this.allCaategory = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  getCuisine() {
    let temp
    this.httpSv.getAllD2Cuisine().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allCuisine = temp
        // console.log(this.allCuisine)
      }
    })
    return (this.allCuisine = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  selectAllForDropdownItems(items: any[]) {
    let allSelect = (items) => {
      items.forEach((element) => {
        element['selectedAllGroup'] = 'selectedAllGroup';
      });
    };
    // console.log(items)
    allSelect(items);
  }
  filter() {
    // console.log(this.dataSource)
    if (this.searchText == "") {
      this.dataSource = new MatTableDataSource(this.restaurantList);
      this.dataSource.paginator = this.paginator1;
    } else {
      let temp = this.restaurantList.filter((ele: any) => {
        return ele.resto_name
          .toLocaleLowerCase()
          .match(this.searchText.toLocaleLowerCase()) || ele.email
            .toLocaleLowerCase()
            .match(this.searchText.toLocaleLowerCase());
      });
      this.dataSource = new MatTableDataSource(temp);

      if (temp.length === 0) {
        let temp = this.restaurantList.filter((ele: any) => {
          return ele.unique_id
            .toLocaleLowerCase()
            .match(this.searchText.toLocaleLowerCase());
        });
        this.dataSource = new MatTableDataSource(temp);
      }
      this.dataSource.paginator = this.paginator1;
    }
  }

  selectedClaimedResto: any = null
  days = [
    { name: 'Monday', short: 'mon' },
    { name: 'Tuesday', short: 'tue' },
    { name: 'Wednesday', short: 'wed' },
    { name: 'Thursday', short: 'thur' },
    { name: 'Friday', short: 'fri' },
    { name: 'Saturday', short: 'sat' },
    { name: 'Sunday', short: 'sun' },
  ];
  updateRestoFunc(newId) {
    this.getData()
    this.getCuisine()
    this.getCategory()
    this.getAllResto()
    this.selectedClaimedResto = newId

    this.oldmonOpenHH = ''
    this.oldmonOpenMM = ''
    this.oldmonOpenMead = 'am'
    this.oldmonPrecheck = false
    this.oldmonCloseHH = ''
    this.oldmonCloseMM = ''
    this.oldmonCloseMead = 'am'
    this.oldtueOpenHH = ''
    this.oldtueOpenMM = ''
    this.oldtueOpenMead = 'am'
    this.oldtueCloseHH = ''
    this.oldtueCloseMM = ''
    this.oldtueCloseMead = 'am'
    this.oldtuePrecheck = false
    this.oldwedOpenHH = ''
    this.oldwedOpenMM = ''
    this.oldwedOpenMead = 'am'
    this.oldwedCloseHH = ''
    this.oldwedCloseMM = ''
    this.oldwedCloseMead = 'am'
    this.oldwedPrecheck = false
    this.oldthurOpenHH = ''
    this.oldthurOpenMM = ''
    this.oldthurOpenMead = 'am'
    this.oldthurCloseHH = ''
    this.oldthurCloseMM = ''
    this.oldthurCloseMead = 'am'
    this.oldthurPrecheck = false
    this.oldfriOpenHH = ''
    this.oldfriOpenMM = ''
    this.oldfriOpenMead = 'am'
    this.oldfriCloseHH = ''
    this.oldfriCloseMM = ''
    this.oldfriCloseMead = 'am'
    this.oldfriPrecheck = false
    this.oldsatOpenHH = ''
    this.oldsatOpenMM = ''
    this.oldsatOpenMead = 'am'
    this.oldsatCloseHH = ''
    this.oldsatCloseMM = ''
    this.oldsatCloseMead = 'am'
    this.oldsatPrecheck = false
    this.oldsunOpenHH = ''
    this.oldsunOpenMM = ''
    this.oldsunOpenMead = 'am'
    this.oldsunCloseHH = ''
    this.oldsunCloseMM = ''
    this.oldsunCloseMead = 'am'
    this.oldsunPrecheck = false


    this.restoNewName = this.selectedClaimedResto.resto_name
    this.restoName = null
    this.restoNewEmail = this.selectedClaimedResto.email
    this.restoEmail = null
    this.restoNewPhone = this.selectedClaimedResto.telephone
    this.restoPhone = null
    this.restoNewDescription = this.selectedClaimedResto.about
    this.restoDescription = null
    this.restoNewWebsite = this.selectedClaimedResto.website
    this.restoWebsite = null
    this.restoNewAddress = this.selectedClaimedResto.address
    this.restoAddress = null

    this.restoNewAvgRating = this.selectedClaimedResto.avg_rating
    this.restoAvgRating = null



    this.selectedNewCuisine = this.selectedClaimedResto.cuisine ? this.selectedClaimedResto.cuisine.split(',') : []
    this.stringSelectedNewCuisine = JSON.stringify(this.selectedNewCuisine)

    this.selectedNewDietaer = this.selectedClaimedResto.dietary ? this.selectedClaimedResto.dietary.split(',') : []
    this.stringSelectedNewDiet = JSON.stringify(this.selectedNewDietaer)

    this.selectedNewCategories = this.selectedClaimedResto.category_id ? this.selectedClaimedResto.category_id.split(',') : []
    this.stringSelectedNewCategory = JSON.stringify(this.selectedNewCategories)


    this.newfeatureSrc = this.selectedClaimedResto.banner_img_1 != 'null' ? this.selectedClaimedResto.banner_img_1 : null

    const openCloseTime = JSON.parse(this.selectedClaimedResto.open_close_time)
    this.days.forEach((day) => {
      if (openCloseTime[day.name] != 'Closed') {
        this[day.short + 'OpenHH'] = openCloseTime[day.name][0].openHH
        this[day.short + 'OpenMM'] = openCloseTime[day.name][0].openMM
        this[day.short + 'OpenMead'] = openCloseTime[day.name][0].openMead
        this[day.short + 'CloseHH'] = openCloseTime[day.name][0].closeHH
        this[day.short + 'CloseMM'] = openCloseTime[day.name][0].closeMM
        this[day.short + 'CloseMead'] = openCloseTime[day.name][0].closeMead
        this[day.short + 'Precheck'] = true
      }
      else this[day.short + 'Precheck'] = false
    })


    let spacialOffer = {}
    if (this.selectedClaimedResto.spacial_offer) {
      spacialOffer = JSON.parse(this.selectedClaimedResto.spacial_offer)
    }
    else {
      spacialOffer = {}
    }
    Object.entries(spacialOffer).forEach(([key, value]) => {

      let offer: any = value

      if (key == 'Monday' && value != 'null' && value != 'NA' && value != '' && value != null) {
        this.offerMonday = true
        this.offerMonValue = offer
      }
      else if (key == 'Tuesday' && value != 'null' && value != 'NA' && value != '' && value != null) {
        this.offerTuesday = true
        this.offerTueValue = offer
      }
      else if (key == 'Wednesday' && value != 'null' && value != 'NA' && value != '' && value != null) {
        this.offerWednesday = true
        this.offerWedValue = offer
      }
      else if (key == 'Thursday' && value != 'null' && value != 'NA' && value != '' && value != null) {
        this.offerTurusday = true
        this.offerThurValue = offer
      }
      else if (key == 'Friday' && value != 'null' && value != 'NA' && value != '' && value != null) {
        this.offerFriday = true
        this.offerFriValue = offer
      }
      else if (key == 'Saturday' && value != 'null' && value != 'NA' && value != '' && value != null) {
        this.offerSaturday = true
        this.offerSatValue = offer
      }
      else if (key == 'Sunday' && value != 'null' && value != 'NA' && value != '' && value != null) {
        this.offerSunday = true
        this.offerSunValue = offer
      }
    })

    if (this.selectedClaimedResto.instagram_link && this.selectedClaimedResto.instagram_link != 'NA' && this.selectedClaimedResto.instagram_link != 'null') {
      this.instagramConNew = true
      this.instagramValNew = this.selectedClaimedResto.instagram_link
    }
    if (this.selectedClaimedResto.facebook_link && this.selectedClaimedResto.facebook_link != 'null') {
      this.facebookConNew = true
      this.facebookValNew = this.selectedClaimedResto.facebook_link
    }
    if (this.selectedClaimedResto.google_map_link && this.selectedClaimedResto.google_map_link != 'null') {
      this.googleMapConNew = true
      this.googleMapValNew = this.selectedClaimedResto.google_map_link
    }


    if (this.selectedClaimedResto.logo) this.NewSrc = this.selectedClaimedResto.logo

    this.claimRestoId = this.selectedClaimedResto.id
    this.restopop = 1
  }
  fillNewData(id) {
    this.httpSv.getOneClaimRestoDetails(id).subscribe(res => {
      if (res['status'] == 'TRUE') {
        this.claimRestoId = res['result'].data.restaurant_id
        // console.log(res['result'].data.csv_restaurantId,'------',this.claimRestoId)
        let temp = res['result'].data
        this.restoNewName = temp.restaurant_name
        this.restoNewEmail = temp.restaurant_email
        this.restoNewPhone = temp.restaurant_telephone
        this.restoNewAddress = temp.restaurant_address
        if (typeof (temp.cuisines) != 'string') {
          this.selectedNewCuisine = temp.cuisines.map(element => {
            return element.cuisine_id
          });
          this.stringSelectedNewCuisine = JSON.stringify(this.selectedNewCuisine)
        }
        if (typeof (temp.categories) != 'string') {
          this.selectedNewCategories = temp.categories.map(element => {
            return element.category_id
          });
          this.stringSelectedNewCategory = JSON.stringify(this.selectedNewCategories)
        }
        if (typeof (temp.allergens) != 'string') {
          this.selectedNewAllergens = temp.allergens.map(element => {
            return element.allergens_id
          });
          this.stringSelctedNewAllegens = JSON.stringify(this.selectedNewAllergens)
        }
        if (typeof (temp.dietary_preferences) != 'string') {
          this.selectedNewDietaer = temp.dietary_preferences.map(element => {
            return element.diet_preference_id
          });
          this.stringSelectedNewDiet = JSON.stringify(this.selectedNewDietaer)
        }
        // console.log(this.selectedNewCuisine)

        if (temp.opening_hours) {
          let time = temp.opening_hours.split(',')
          time.forEach(element => {
            let day = element.split(':')[0]
            let temp1 = element.split(':')
            if (day == 'Monday') {
              if (temp1[1] != 'null') {
                this.monOpenHH = temp1[1]
                this.monOpenMM = temp1[2]
                this.monOpenMead = temp1[3]
                this.monCloseHH = temp1[4]
                this.monCloseMM = temp1[5]
                this.monCloseMead = temp1[6]
                this.monPrecheck = true
              }
            }
            else if (day == 'Tuesday') {
              if (temp1[1] != 'null') {
                this.tueOpenHH = temp1[1]
                this.tueOpenMM = temp1[2]
                this.tueOpenMead = temp1[3]
                this.tueCloseHH = temp1[4]
                this.tueCloseMM = temp1[5]
                this.tueCloseMead = temp1[6]
                this.tuePrecheck = true
              }
            }
            else if (day == 'Wednesday') {
              if (temp1[1] != 'null') {
                this.wedOpenHH = temp1[1]
                this.wedOpenMM = temp1[2]
                this.wedOpenMead = temp1[3]
                this.wedCloseHH = temp1[4]
                this.wedCloseMM = temp1[5]
                this.wedCloseMead = temp1[6]
                this.wedPrecheck = true
              }
            }
            else if (day == 'Thursday') {
              if (temp1[1] != 'null') {
                this.thurOpenHH = temp1[1]
                this.thurOpenMM = temp1[2]
                this.thurOpenMead = temp1[3]
                this.thurCloseHH = temp1[4]
                this.thurCloseMM = temp1[5]
                this.thurCloseMead = temp1[6]
                this.thurPrecheck = true

              }
            }
            else if (day == 'Friday') {
              if (temp1[1] != 'null') {
                this.friOpenHH = temp1[1]
                this.friOpenMM = temp1[2]
                this.friOpenMead = temp1[3]
                this.friCloseHH = temp1[4]
                this.friCloseMM = temp1[5]
                this.friCloseMead = temp1[6]
                this.friPrecheck = true
              }
            }
            else if (day == 'Saturday') {
              if (temp1[1] != 'null') {
                this.satOpenHH = temp1[1]
                this.satOpenMM = temp1[2]
                this.satOpenMead = temp1[3]
                this.satCloseHH = temp1[4]
                this.satCloseMM = temp1[5]
                this.satCloseMead = temp1[6]
                this.satPrecheck = true
              }
            }
            else {
              if (temp1[1] != 'null') {
                this.sunOpenHH = temp1[1]
                this.sunOpenMM = temp1[2]
                this.sunOpenMead = temp1[3]
                this.sunCloseHH = temp1[4]
                this.sunCloseMM = temp1[5]
                this.sunCloseMead = temp1[6]
                this.sunPrecheck = true
              }
            }
          });
        }
        console.log(temp.opening_hours)
        if (temp.special_offer) {
          let offersArr = temp.special_offer.split(',')
          offersArr.forEach(element => {
            let day = element.split(':')[0]
            let temp1 = element.split(':')
            if (day == 'Monday') {
              if (temp1[1] != 'null') {
                this.offerMonday = true
                this.offerMonValue = temp1[1]
              }
            }
            else if (day == 'Tuesday') {
              if (temp1[1] != 'null') {
                this.offerTuesday = true
                this.offerTueValue = temp1[1]
              }
            }
            else if (day == 'Wednesday') {
              if (temp1[1] != 'null') {
                this.offerWednesday = true
                this.offerWedValue = temp1[1]
              }
            }
            else if (day == 'Thursday') {
              if (temp1[1] != 'null') {
                this.offerTurusday = true
                this.offerThurValue = temp1[1]

              }
            }
            else if (day == 'Friday') {
              if (temp1[1] != 'null') {
                this.offerFriday = true
                this.offerFriValue = temp1[1]
              }
            }
            else if (day == 'Saturday') {
              if (temp1[1] != 'null') {
                this.offerSaturday = true
                this.offerSatValue = temp1[1]
              }
            }
            else {
              if (temp1[1] != 'null') {
                this.offerSunday = true
                this.offerSunValue = temp1[1]
              }
            }
          });
        }
        if (temp.delivery_partner) {
          let deliverArr = temp.delivery_partner.split(',')
          // console.log(deliverArr)
          deliverArr.forEach(element => {
            let [partnerName, ...temp1] = element.split(':')
            temp1 = temp1.join(':')
            // console.log(partnerName, temp1)
            // let temp1 = element.split(':')
            if (partnerName == 'Deliveroo') {
              if (temp1 != 'null') {
                this.delverooConNew = true
                this.delverooValNew = temp1
              }
            }
            else if (partnerName == 'JustEat') {
              if (temp1 != 'null') {
                this.justEatConNew = true
                this.justEatValNew = temp1
              }
            }
            else if (partnerName == 'UberEats') {
              if (temp1 != 'null') {
                this.uberEatsConNew = true
                this.uberEatsValNew = temp1
              }
            }
            else if (partnerName == 'Foodstuff') {
              if (temp1 != 'null') {
                this.foodstuffConNew = true
                this.foodstuffValNew = temp1
              }
            }
          });
          // console.log(this.uberEatsConNew, this.justEatConNew)
        }
        if (temp.instagram_link && temp.instagram_link != 'NA') {
          this.instagramConNew = true
          this.instagramValNew = temp.instagram_link
        }
        if (temp.social_link) {
          this.facebookConNew = true
          this.facebookValNew = temp.social_link
        }
        if (temp.google_map_url) {
          this.googleMapConNew = true
          this.googleMapValNew = temp.google_map_url
        }
        if (temp.appropriate_food_allergy_message == 'A' || temp.appropriate_food_allergy_message == 'B' || temp.appropriate_food_allergy_message == 'C')
          this.approAns = temp.appropriate_food_allergy_message
        else {
          this.approAns = 'D'
          this.queAnsOtherTextNew = temp.appropriate_food_allergy_message
        }
        if (temp.logo) this.NewSrc = temp.logo
        if (temp.featured_image) this.newfeatureSrc = temp.featured_image
        if (temp.menu_name_link) {
          let menuNameLink
          if (temp.menu_name_link.length > 1) menuNameLink = temp.menu_name_link.split(',')
          else menuNameLink = temp.menu_name_link[0]
          if (menuNameLink[0].includes('.pdf') || (menuNameLink.length > 1 || menuNameLink[0].includes('.png') || menuNameLink[0].includes('.jpg') || menuNameLink[0].includes('.jpeg') || menuNameLink[0].includes('.svg')) && typeof (menuNameLink) != 'string') {
            if (temp.menu_name) {
              if (temp.menu_name[0].includes('.pdf')) {
                this.menuPdfCondition = true
                this.newpdfRedirctVar = temp.menu_name[0]
                this.stringNewPdfSrc = JSON.stringify(this.newpdfRedirctVar)
                let splitArr = temp.menu_name[0].split('/')
                this.newpdfMenuSrc = splitArr[splitArr.length - 1]
                this.pdfConditionMenu = true
              }
              else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg')) && typeof (temp.menu_name) != 'string') {
                this.menuImgCondition = true
                temp.menu_name.forEach(element => {
                  this.newmenuSrc.push({ src: element })
                });
                this.stringNewMenu = JSON.stringify(this.newmenuSrc)
                this.imgConditionMenu = true
              }
            }

            // let menuNameLink = temp.menu_name_link.split(',')
            if (menuNameLink[0].includes('.pdf')) {
              this.menuPdfCondition = true
              this.newpdfRedirctVar = temp.menu_name[0]
              this.stringNewPdfSrc = JSON.stringify(this.newpdfRedirctVar)
              let splitArr = temp.menu_name[0].split('/')
              this.newpdfMenuSrc = splitArr[splitArr.length - 1]
              this.pdfConditionMenu = true
            }
            else if ((menuNameLink.length > 1 || menuNameLink[0].includes('.png') || menuNameLink[0].includes('.jpg') || menuNameLink[0].includes('.jpeg') || menuNameLink[0].includes('.svg')) && typeof (menuNameLink) != 'string') {
              // console.log('works 2')
              this.menuImgCondition = true
              menuNameLink.forEach(element => {
                this.newmenuSrc.push({ src: element })
              });
              this.stringNewMenu = JSON.stringify(this.newmenuSrc)
              this.imgConditionMenu = true
            }
          }
          else {
            this.menuLinkConditionNew = true
            this.urlLinkNew = menuNameLink
          }
        }
        else {
          if (temp.menu_name) {
            if (temp.menu_name[0].includes('.pdf')) {
              this.menuPdfCondition = true
              this.newpdfRedirctVar = temp.menu_name[0]
              this.stringNewPdfSrc = JSON.stringify(this.newpdfRedirctVar)
              let splitArr = temp.menu_name[0].split('/')
              this.newpdfMenuSrc = splitArr[splitArr.length - 1]
              this.pdfConditionMenu = true
            }
            else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg')) && typeof (temp.menu_name) != 'string') {
              this.menuImgCondition = true
              temp.menu_name.forEach(element => {
                this.newmenuSrc.push({ src: element })
              });
              this.stringNewMenu = JSON.stringify(this.newmenuSrc)
              this.imgConditionMenu = true
            }
          }
        }
        if (temp.description_and_tags) {
          this.otherDescriptionOrTagsNew = temp.description_and_tags
        }
      }
    })
  }

  triggerEmail(element: any) {
    if (this.l1_approved) this.sendEmail(element)
    else if (this.l2) this.sendCrendential(element)
  }

  sendCrendential(data: any) {
    const payload = {
      restaurant_id: data.id,
    }

    this.httpSv.sendCredentialsEmail(payload).subscribe(res => {
      if (res['status'] == 'TRUE') {
        this._snackBar.open('Email sent successfully');
        this.getAllResto()
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
      } else {
        this._snackBar.open(res['message']);
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
      }
    }, err => {
      this._snackBar.open('Oops!! Something went wrong');
      setTimeout(() => {
        this._snackBar.dismiss();
      }, 2000);
      console.log(err);
    })
  }


  sendEmail(data: any) {
    const payload = {
      id: data.id,
      email: data.email,
      name: data.resto_name,
      address: data.address,
      logo: data.logo,
    }

    this.httpSv.sendRemiderEmail(payload).subscribe(res => {
      if (res['status'] == 'TRUE') {
        this._snackBar.open('Email sent successfully');
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
      } else {
        this._snackBar.open(res['message']);
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
      }
    }, err => {
      this._snackBar.open('Oops!! Something went wrong');
      setTimeout(() => {
        this._snackBar.dismiss();
      }, 2000);
      console.log(err);
    })
  }


  restoLat
  restoLong
  fillOldData(id) {
    this.httpSv.getOneD2RestoDetails(id).subscribe(res => {
      if (res['status'] == 'TRUE') {
        let temp = res['result'].data
        this.restoName = temp.restaurant_name
        this.restoEmail = temp.restaurant_email
        this.restoPhone = temp.restaurant_telephone
        this.restoAddress = temp.restaurant_address
        if (typeof (temp.cuisines) != 'string') {
          this.selectedCuisine = temp.cuisines.map(element => {
            return element.cuisine_id
          });
          this.stringSelectedCuisine = JSON.stringify(this.selectedCuisine)
        }
        if (typeof (temp.categories) != 'string') {
          this.selectedCaategory = temp.categories.map(element => {
            return element.category_id
          });
          this.stringSelectedCategory = JSON.stringify(this.selectedCaategory)
        }
        if (typeof (temp.allergens) != 'string') {
          this.selectedAllegens = temp.allergens.map(element => {
            return element.allergens_id
          });
          this.stringSelctedAllegens = JSON.stringify(this.selectedAllegens)
        }
        if (typeof (temp.dietary_preferences) != 'string') {
          this.selectedDieatry = temp.dietary_preferences.map(element => {
            return element.diet_preference_id
          });
          this.stringSelectedDiet = JSON.stringify(this.selectedDieatry)
        }
        // if (temp.opening_hours) {
        //   let time = temp.opening_hours.split(',')
        //   time.forEach(element => {
        //     let day = element.split(':')[0]
        //     let temp1 = element.split(':')
        //     if (day == 'Monday') {
        //       if (temp1[1] != 'null') {
        //         this.oldmonOpenHH = temp1[1]
        //         this.oldmonOpenMM = temp1[2]
        //         this.oldmonOpenMead = temp1[3]
        //         this.oldmonCloseHH = temp1[4]
        //         this.oldmonCloseMM = temp1[5]
        //         this.oldmonCloseMead = temp1[6]
        //         this.oldmonPrecheck = true
        //       }
        //     }
        //     else if (day == 'Tuesday') {
        //       if (temp1[1] != 'null') {
        //         this.oldtueOpenHH = temp1[1]
        //         this.oldtueOpenMM = temp1[2]
        //         this.oldtueOpenMead = temp1[3]
        //         this.oldtueCloseHH = temp1[4]
        //         this.oldtueCloseMM = temp1[5]
        //         this.oldtueCloseMead = temp1[6]
        //         this.oldtuePrecheck = true
        //       }
        //     }
        //     else if (day == 'Wednesday') {
        //       if (temp1[1] != 'null') {
        //         this.oldwedOpenHH = temp1[1]
        //         this.oldwedOpenMM = temp1[2]
        //         this.oldwedOpenMead = temp1[3]
        //         this.oldwedCloseHH = temp1[4]
        //         this.oldwedCloseMM = temp1[5]
        //         this.oldwedCloseMead = temp1[6]
        //         this.oldwedPrecheck = true
        //       }
        //     }
        //     else if (day == 'Thursday') {
        //       if (temp1[1] != 'null') {
        //         this.oldthurOpenHH = temp1[1]
        //         this.oldthurOpenMM = temp1[2]
        //         this.oldthurOpenMead = temp1[3]
        //         this.oldthurCloseHH = temp1[4]
        //         this.oldthurCloseMM = temp1[5]
        //         this.oldthurCloseMead = temp1[6]
        //         this.oldthurPrecheck = true

        //       }
        //     }
        //     else if (day == 'Friday') {
        //       if (temp1[1] != 'null') {
        //         this.oldfriOpenHH = temp1[1]
        //         this.oldfriOpenMM = temp1[2]
        //         this.oldfriOpenMead = temp1[3]
        //         this.oldfriCloseHH = temp1[4]
        //         this.oldfriCloseMM = temp1[5]
        //         this.oldfriCloseMead = temp1[6]
        //         this.oldfriPrecheck = true
        //       }
        //     }
        //     else if (day == 'Saturday') {
        //       if (temp1[1] != 'null') {
        //         this.oldsatOpenHH = temp1[1]
        //         this.oldsatOpenMM = temp1[2]
        //         this.oldsatOpenMead = temp1[3]
        //         this.oldsatCloseHH = temp1[4]
        //         this.oldsatCloseMM = temp1[5]
        //         this.oldsatCloseMead = temp1[6]
        //         this.oldsatPrecheck = true
        //       }
        //     }
        //     else {
        //       if (temp1[1] != 'null') {
        //         this.oldsunOpenHH = temp1[1]
        //         this.oldsunOpenMM = temp1[2]
        //         this.oldsunOpenMead = temp1[3]
        //         this.oldsunCloseHH = temp1[4]
        //         this.oldsunCloseMM = temp1[5]
        //         this.oldsunCloseMead = temp1[6]
        //         this.oldsunPrecheck = true
        //       }
        //     }
        //   });
        // }
        if (temp.opening_hours) {
          let time = temp.opening_hours.split(',')
          time.forEach(element => {
            element = element.replaceAll(/\s/g, '')
            let temp1
            let dayTime
            let openHH
            let openMM
            let openMead = 'am'
            let closeHH
            let closeMM
            let closeMead = 'am'
            let flag
            let [day, ...time] = element.split(':')
            dayTime = time.join(':')
            dayTime = dayTime.replace('[', '')
            dayTime = dayTime.replace(']', '')
            temp1 = dayTime.split('-')
            if (temp1[0] != 'Closed') {

              if (temp1[0].includes(':')) {
                let temp = temp1[0].split(':')
                openHH = temp[0]
                if (temp[1].length > 2) {
                  let num = temp[1].match(/\d+/g);
                  let letr = temp[1].match(/[a-zA-Z]+/g);
                  openMM = num[0]
                  openMead = letr[0]
                  flag = true
                }
                else {
                  openMM = temp1[1]
                  flag = false
                }
              }
              else {
                openMM = '00'
                if (temp1[0].length > 2) {
                  let num = temp1[0].match(/\d+/g);
                  let letr = temp1[0].match(/[a-zA-Z]+/g);
                  openHH = num[0]
                  openMead = letr[0]
                  flag = true
                }
                else {
                  openHH = temp1[0]
                  flag = false
                }
              }

              if (temp1[1].includes(':')) {
                let temp = temp1[1].split(':')
                closeHH = temp[0]
                let num = temp[1].match(/\d+/g);
                let letr = temp[1].match(/[a-zA-Z]+/g);
                closeMM = num[0]
                closeMead = letr[0]

                if (!flag) {
                  openMead = closeMead
                }

              }
              else {
                closeMM = '00'
                let num = temp1[1].match(/\d+/g);
                let letr = temp1[1].match(/[a-zA-Z]+/g);
                closeHH = num[0]
                closeMead = letr[0]

                if (!flag) {
                  openMead = closeMead
                }

              }
              day = day.trim()
              if (day == 'Monday') {
                if (dayTime != 'null') {

                  this.oldmonOpenHH = openHH
                  this.oldmonOpenMM = openMM
                  this.oldmonOpenMead = openMead
                  this.oldmonCloseHH = closeHH
                  this.oldmonCloseMM = closeMM
                  this.oldmonCloseMead = closeMead
                  this.oldmonPrecheck = true

                }
              }
              else if (day == 'Tuesday') {
                if (temp1[1] != 'null') {
                  this.oldtueOpenHH = openHH
                  this.oldtueOpenMM = openMM
                  this.oldtueOpenMead = openMead
                  this.oldtueCloseHH = closeHH
                  this.oldtueCloseMM = closeMM
                  this.oldtueCloseMead = closeMead
                  this.oldtuePrecheck = true

                }
              }
              else if (day == 'Wednesday') {
                if (temp1[1] != 'null') {
                  this.oldwedOpenHH = openHH
                  this.oldwedOpenMM = openMM
                  this.oldwedOpenMead = openMead
                  this.oldwedCloseHH = closeHH
                  this.oldwedCloseMM = closeMM
                  this.oldwedCloseMead = closeMead
                  this.oldwedPrecheck = true

                }
              }
              else if (day == 'Thursday') {
                if (temp1[1] != 'null') {
                  this.oldthurOpenHH = openHH
                  this.oldthurOpenMM = openMM
                  this.oldthurOpenMead = openMead
                  this.oldthurCloseHH = closeHH
                  this.oldthurCloseMM = closeMM
                  this.oldthurCloseMead = closeMead
                  this.oldthurPrecheck = true


                }
              }
              else if (day == 'Friday') {
                if (temp1[1] != 'null') {
                  this.oldfriOpenHH = openHH
                  this.oldfriOpenMM = openMM
                  this.oldfriOpenMead = openMead
                  this.oldfriCloseHH = closeHH
                  this.oldfriCloseMM = closeMM
                  this.oldfriCloseMead = closeMead
                  this.oldfriPrecheck = true

                }
              }
              else if (day == 'Saturday') {
                if (temp1[1] != 'null') {
                  this.oldsatOpenHH = openHH
                  this.oldsatOpenMM = openMM
                  this.oldsatOpenMead = openMead
                  this.oldsatCloseHH = closeHH
                  this.oldsatCloseMM = closeMM
                  this.oldsatCloseMead = closeMead
                  this.oldsatPrecheck = true

                }
              }
              else {
                if (temp1[1] != 'null') {
                  this.oldsunOpenHH = openHH
                  this.oldsunOpenMM = openMM
                  this.oldsunOpenMead = openMead
                  this.oldsunCloseHH = closeHH
                  this.oldsunCloseMM = closeMM
                  this.oldsunCloseMead = closeMead
                  this.oldsunPrecheck = true

                }
              }
            }
          });
        }
        // if (temp.restaurant_special_offer) {
        //   let offersArr = temp.restaurant_special_offer.split(',')
        //   offersArr.forEach(element => {
        //     let day = element.split(':')[0]
        //     let temp1 = element.split(':')
        //     if (day == 'Monday') {
        //       if (temp1[1] != 'null') {
        //         this.offerMonday = true
        //         this.offerMonValue = temp1[1]
        //       }
        //     }
        //     else if (day == 'Tuesday') {
        //       if (temp1[1] != 'null') {
        //         this.offerTuesday = true
        //         this.offerTueValue = temp1[1]
        //       }
        //     }
        //     else if (day == 'Wednesday') {
        //       if (temp1[1] != 'null') {
        //         this.offerWednesday = true
        //         this.offerWedValue = temp1[1]
        //       }
        //     }
        //     else if (day == 'Thursday') {
        //       if (temp1[1] != 'null') {
        //         this.offerTurusday = true
        //         this.offerThurValue = temp1[1]

        //       }
        //     }
        //     else if (day == 'Friday') {
        //       if (temp1[1] != 'null') {
        //         this.offerFriday = true
        //         this.offerFriValue = temp1[1]
        //       }
        //     }
        //     else if (day == 'Saturday') {
        //       if (temp1[1] != 'null') {
        //         this.offerSaturday = true
        //         this.offerSatValue = temp1[1]
        //       }
        //     }
        //     else {
        //       if (temp1[1] != 'null') {
        //         this.offerSunday = true
        //         this.offerSunValue = temp1[1]
        //       }
        //     }
        //   });
        // }
        if (temp.logo) this.src = temp.logo
        if (temp.featured_image) this.featureSrc = temp.featured_image
        if (temp.menu_name_link) {
          let menuNameLink = temp.menu_name_link
          // if (temp.menu_name_link.length > 1) menuNameLink = temp.menu_name_link[0].split(',')
          // else menuNameLink = temp.menu_name_link[0]
          console.log(menuNameLink[0].includes('.jpg'))
          if (menuNameLink[0].includes('.pdf') || menuNameLink.length > 1 || menuNameLink[0].includes('.png') || menuNameLink[0].includes('.jpg') || menuNameLink[0].includes('.jpeg') || menuNameLink[0].includes('.svg')) {
            console.log('menuNameLink[0].includes()')
            if (temp.menu_name) {
              if (temp.menu_name[0].includes('.pdf')) {
                this.menuPdfCondition = true
                this.pdfRedirctVar = temp.menu_name[0]
                let splitArr = temp.menu_name[0].split('/')
                this.pdfMenuSrc = splitArr[splitArr.length - 1]
                this.pdfConditionMenu = true
              }
              else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg'))) {
                this.menuImgCondition = true
                temp.menu_name.forEach(element => {
                  this.menuSrc.push({ src: element })
                });
                this.imgConditionMenu = true
              }
            }
            if (temp.menu_name_link) {
              let menuNameLink = temp.menu_name_link
              if (menuNameLink[0].includes('.pdf')) {
                this.menuPdfCondition = true
                this.pdfRedirctVar = temp.menu_name[0]
                let splitArr = temp.menu_name[0].split('/')
                this.pdfMenuSrc = splitArr[splitArr.length - 1]
                this.pdfConditionMenu = true
              }
              else if ((menuNameLink.length > 1 || menuNameLink[0].includes('.png') || menuNameLink[0].includes('.jpg') || menuNameLink[0].includes('.jpeg') || menuNameLink[0].includes('.svg')) && typeof (menuNameLink) != 'string') {
                // console.log('works 2')
                this.menuImgCondition = true
                menuNameLink.forEach(element => {
                  this.menuSrc.push({ src: element })
                });
                this.imgConditionMenu = true
              }
            }
          }
          else {
            this.menuLinkCondition = true
            this.urlLink = menuNameLink
          }
        }
        else {
          if (temp.menu_name) {
            if (temp.menu_name[0].includes('.pdf')) {
              this.menuPdfCondition = true
              this.pdfRedirctVar = temp.menu_name[0]
              let splitArr = temp.menu_name[0].split('/')
              this.pdfMenuSrc = splitArr[splitArr.length - 1]
              this.pdfConditionMenu = true
            }
            else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg')) && typeof (temp.menu_name) != 'string') {
              this.menuImgCondition = true
              temp.menu_name.forEach(element => {
                this.menuSrc.push({ src: element })
              });
              this.imgConditionMenu = true
            }
          }
        }
        // if (temp.menu_name_link) {
        //   let menuNameLink
        //   if (temp.menu_name_link.length > 1) menuNameLink = temp.menu_name_link.split(',')
        //   else menuNameLink = temp.menu_name_link[0]
        //   if (menuNameLink[0].includes('.pdf') || (menuNameLink.length > 1 || menuNameLink[0].includes('.png') || menuNameLink[0].includes('.jpg') || menuNameLink[0].includes('.jpeg') || menuNameLink[0].includes('.svg')) && typeof (menuNameLink) != 'string') {
        //     if (temp.menu_name) {
        //       if (temp.menu_name[0].includes('.pdf')) {
        //         this.menuPdfCondition = true
        //         this.newpdfRedirctVar = temp.menu_name[0]
        //         this.stringNewPdfSrc = JSON.stringify(this.newpdfRedirctVar)
        //         let splitArr = temp.menu_name[0].split('/')
        //         this.newpdfMenuSrc = splitArr[splitArr.length - 1]
        //         this.pdfConditionMenu = true
        //       }
        //       else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg')) && typeof (temp.menu_name) != 'string') {
        //         this.menuImgCondition = true
        //         temp.menu_name.forEach(element => {
        //           this.newmenuSrc.push({ src: element })
        //         });
        //         this.stringNewMenu = JSON.stringify(this.newmenuSrc)
        //         this.imgConditionMenu = true
        //       }
        //     }

        //     // let menuNameLink = temp.menu_name_link.split(',')
        //     if (menuNameLink[0].includes('.pdf')) {
        //       this.menuPdfCondition = true
        //       this.pdfRedirctVar = temp.menu_name[0]
        //       this.stringOldPdfSrc = JSON.stringify(this.newpdfRedirctVar)
        //       let splitArr = temp.menu_name[0].split('/')
        //       this.pdfMenuSrc = splitArr[splitArr.length - 1]
        //       this.pdfConditionMenu = true
        //     }
        //     else if ((menuNameLink.length > 1 || menuNameLink[0].includes('.png') || menuNameLink[0].includes('.jpg') || menuNameLink[0].includes('.jpeg') || menuNameLink[0].includes('.svg')) && typeof (menuNameLink) != 'string') {
        //       this.menuImgCondition = true
        //       menuNameLink.forEach(element => {
        //         this.menuSrc.push({ src: element })
        //       });
        //       this.stringOldMenu = JSON.stringify(this.newmenuSrc)
        //       this.imgConditionMenu = true
        //     }
        //     else {
        //       this.menuLinkCondition = true
        //       this.urlLink = menuNameLink
        //     }
        //   }
        //   else {
        //     if (temp.menu_name[0].includes('.pdf')) {
        //       this.menuPdfCondition = true
        //       this.pdfRedirctVar = temp.menu_name[0]
        //       this.stringOldPdfSrc = JSON.stringify(this.pdfRedirctVar)
        //       let splitArr = temp.menu_name[0].split('/')
        //       this.pdfMenuSrc = splitArr[splitArr.length - 1]
        //       this.pdfConditionMenu = true
        //     }
        //     else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg')) && typeof (temp.menu_name) != 'string') {
        //       this.menuImgCondition = true
        //       temp.menu_name.forEach(element => {
        //         this.menuSrc.push({ src: element })
        //       });
        //       this.stringOldMenu = JSON.stringify(this.menuSrc)
        //       this.imgConditionMenu = true
        //     }
        //     if (temp.instagram_link && temp.instagram_link != 'NA') {
        //       this.instagramCon = true
        //       this.instagramVal = temp.instagram_link
        //     }
        //     if (temp.social_link) {
        //       this.facebookCon = true
        //       this.facebookVal = temp.social_link
        //     }
        //   }
        //   if (temp.menu_name[0].includes('.pdf')) {
        //     this.menuPdfCondition = true
        //     this.pdfRedirctVar = temp.menu_name[0]
        //     this.stringOldPdfSrc = JSON.stringify(this.pdfRedirctVar)
        //     let splitArr = temp.menu_name[0].split('/')
        //     this.pdfMenuSrc = splitArr[splitArr.length - 1]
        //     this.pdfConditionMenu = true
        //   }
        //   else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg')) && typeof (temp.menu_name) != 'string') {
        //     this.menuImgCondition = true
        //     temp.menu_name.forEach(element => {
        //       this.menuSrc.push({ src: element })
        //     });
        //     this.stringOldMenu = JSON.stringify(this.menuSrc)
        //     this.imgConditionMenu = true
        //   }
        // }
        if (temp.instagram_link && temp.instagram_link != 'NA' && temp.instagram_link != 'null') {
          this.instagramCon = true
          this.instagramVal = temp.instagram_link
        }
        if (temp.social_link) {
          this.facebookCon = true
          this.facebookVal = temp.social_link
        }
        console.log(temp.google_map_url)
        if (temp.google_map_url && temp.google_map_url != 'null') {
          this.googleMapCon = true
          this.googleMapVal = temp.google_map_url
        }
        if (temp.appropriate_food_allergy_message) {
          if (temp.appropriate_food_allergy_message == 'A' || temp.appropriate_food_allergy_message == 'B' || temp.appropriate_food_allergy_message == 'C')
            this.approOldAns = temp.appropriate_food_allergy_message
          else {
            this.approOldAns = 'D'
            this.queAnsOtherText = temp.appropriate_food_allergy_message
          }
        }
        if (temp.delivery_partner) {
          let deliverArr = temp.delivery_partner.split(',')
          // console.log(deliverArr)
          deliverArr.forEach(element => {
            let [partnerName, ...temp1] = element.split(':')
            temp1 = temp1.join(':')
            // console.log(partnerName, temp1)
            // let temp1 = element.split(':')
            if (partnerName == 'Deliveroo') {
              if (temp1 != 'null') {
                this.delverooCon = true
                this.delverooVal = temp1
              }
            }
            else if (partnerName == 'JustEat') {
              if (temp1 != 'null') {
                this.justEatCon = true
                this.justEatVal = temp1
              }
            }
            else if (partnerName == 'UberEats') {
              if (temp1 != 'null') {
                this.uberEatsCon = true
                this.uberEatsVal = temp1
              }
            }
            else if (partnerName == 'Foodstuff') {
              if (temp1 != 'null') {
                this.foodstuffCon = true
                this.foodstuffVal = temp1
              }
            }

          });
        }
        if (temp.description_and_tags) {
          this.otherDescriptionOrTags = temp.description_and_tags
        }
        this.restoLat = temp.restaurant_lat
        this.restoLong = temp.restaurant_long

      }
    })
  }

  copyAllToMain() {
    this.restoName = this.restoNewName
    this.restoEmail = this.restoNewEmail
    this.restoPhone = this.restoNewPhone
    this.restoAddress = this.restoNewAddress
    this.restoWebsite = this.restoNewWebsite
    this.restoDescription = this.restoNewDescription
    this.restoAvgRating = this.restoNewAvgRating
    {
      this.selectedCuisine = this.selectedNewCuisine.map(ele => ele)
      this.stringSelectedCuisine = JSON.stringify(this.selectedCuisine)
      this.stringSelectedNewCuisine = JSON.stringify(this.selectedNewCuisine)
      let element = document.getElementById('cuisine').children
      let newElement = document.getElementById('cuisineNew').children
      for (let i = 0; i < element.length; i++) {
        if (newElement[i].children[0]['checked']) {
          element[i].children[0]['checked'] = true
        }
        else {
          element[i].children[0]['checked'] = false
        }
      }
    }

    {
      this.selectedCaategory = this.selectedNewCategories.map(ele => ele)
      this.stringSelectedCategory = JSON.stringify(this.selectedCaategory)
      this.stringSelectedNewCategory = JSON.stringify(this.selectedNewCategories)
      let element = document.getElementById('categories').children
      let newElement = document.getElementById('categoriesNew').children
      for (let i = 0; i < element.length; i++) {
        if (newElement[i].children[0]['checked']) {
          element[i].children[0]['checked'] = true
        }
        else {
          element[i].children[0]['checked'] = false
        }
      }
    }

    {
      this.selectedDieatry = this.selectedNewDietaer.map(ele => ele)
      this.stringSelectedDiet = JSON.stringify(this.selectedDieatry)
      this.stringSelectedNewDiet = JSON.stringify(this.selectedNewDietaer)
      let element = document.getElementById('dietPref').children
      let newElement = document.getElementById('dietPrefNew').children
      for (let i = 0; i < element.length; i++) {
        if (newElement[i].children[0]['checked']) {
          element[i].children[0]['checked'] = true
        }
        else {
          element[i].children[0]['checked'] = false
        }
      }
    }

    this.oldmonOpenHH = this.monOpenHH
    this.oldmonOpenMM = this.monOpenMM
    this.oldmonOpenMead = this.monOpenMead
    this.oldmonPrecheck = this.monPrecheck
    this.oldmonCloseHH = this.monCloseHH
    this.oldmonCloseMM = this.monCloseMM
    this.oldmonCloseMead = this.monCloseMead
    this.oldtueOpenHH = this.tueOpenHH
    this.oldtueOpenMM = this.tueOpenMM
    this.oldtueOpenMead = this.tueCloseMead
    this.oldtueCloseHH = this.tueCloseHH
    this.oldtueCloseMM = this.tueCloseMM
    this.oldtueCloseMead = this.tueCloseMead
    this.oldtuePrecheck = this.tuePrecheck
    this.oldwedOpenHH = this.wedOpenHH
    this.oldwedOpenMM = this.wedOpenMM
    this.oldwedOpenMead = this.wedOpenMead
    this.oldwedCloseHH = this.wedCloseHH
    this.oldwedCloseMM = this.wedCloseMM
    this.oldwedCloseMead = this.wedCloseMead
    this.oldwedPrecheck = this.wedPrecheck
    this.oldthurOpenHH = this.thurOpenHH
    this.oldthurOpenMM = this.thurOpenMM
    this.oldthurOpenMead = this.thurOpenMead
    this.oldthurCloseHH = this.thurCloseHH
    this.oldthurCloseMM = this.thurCloseMM
    this.oldthurCloseMead = this.thurCloseMead
    this.oldthurPrecheck = this.thurPrecheck
    this.oldfriOpenHH = this.friOpenHH
    this.oldfriOpenMM = this.friOpenMM
    this.oldfriOpenMead = this.friOpenMead
    this.oldfriCloseHH = this.friCloseHH
    this.oldfriCloseMM = this.friCloseMM
    this.oldfriCloseMead = this.friCloseMead
    this.oldfriPrecheck = this.friPrecheck
    this.oldsatOpenHH = this.satOpenHH
    this.oldsatOpenMM = this.satOpenMM
    this.oldsatOpenMead = this.satOpenMead
    this.oldsatCloseHH = this.satCloseHH
    this.oldsatCloseMM = this.satCloseMM
    this.oldsatCloseMead = this.satCloseMead
    this.oldsatPrecheck = this.satPrecheck
    this.oldsunOpenHH = this.sunOpenHH
    this.oldsunOpenMM = this.sunOpenMM
    this.oldsunOpenMead = this.sunOpenMead
    this.oldsunCloseHH = this.sunCloseHH
    this.oldsunCloseMM = this.sunCloseMM
    this.oldsunCloseMead = this.sunCloseMead
    this.oldsunPrecheck = this.sunPrecheck

    document.getElementById('timeOldMon')['checked'] = document.getElementById('timeNewMon')['checked']
    document.getElementById('timeOldTue')['checked'] = document.getElementById('timeNewTue')['checked']
    document.getElementById('timeOldWed')['checked'] = document.getElementById('timeNewWed')['checked']
    document.getElementById('timeOldThu')['checked'] = document.getElementById('timeNewThu')['checked']
    document.getElementById('timeOldFri')['checked'] = document.getElementById('timeNewFri')['checked']
    document.getElementById('timeOldSat')['checked'] = document.getElementById('timeNewSat')['checked']
    document.getElementById('timeOldSun')['checked'] = document.getElementById('timeNewSun')['checked']

    this.offerOldMonday = this.offerMonday
    this.offerOldTuesday = this.offerTuesday
    this.offerOldWednesday = this.offerWednesday
    this.offerOldTurusday = this.offerTurusday
    this.offerOldFriday = this.offerFriday
    this.offerOldSaturday = this.offerSaturday
    this.offerOldSunday = this.offerSunday
    this.offerOldMonValue = this.offerMonValue
    this.offerOldTueValue = this.offerTueValue
    this.offerOldWedValue = this.offerWedValue
    this.offerOldThurValue = this.offerThurValue
    this.offerOldFriValue = this.offerFriValue
    this.offerOldSatValue = this.offerSatValue
    this.offerOldSunValue = this.offerSunValue

    this.delverooCon = this.delverooConNew
    this.justEatCon = this.justEatConNew
    this.uberEatsCon = this.uberEatsConNew
    this.foodstuffCon = this.foodstuffConNew
    this.delverooVal = this.delverooValNew
    this.justEatVal = this.justEatValNew
    this.uberEatsVal = this.uberEatsValNew
    this.foodstuffVal = this.foodstuffValNew

    this.instagramCon = this.instagramConNew
    this.facebookCon = this.facebookConNew
    this.googleMapCon = this.googleMapConNew
    this.instagramVal = this.instagramValNew
    this.facebookVal = this.facebookValNew
    this.googleMapVal = this.googleMapValNew

    if (this.approAns == 'A' || this.approAns == 'B' || this.approAns == 'C')
      this.approOldAns = this.approAns
    else {
      this.approOldAns = this.approAns
      this.queAnsOtherText = this.queAnsOtherTextNew
    }

    this.src = this.NewSrc
    this.logoToBeAppend = null

    this.featureSrc = this.newfeatureSrc
    this.featureImgToBeAppend = null

    if (this.menuLinkConditionNew) {
      this.menuLinkCondition = true
      this.urlLink = this.urlLinkNew
    }
    else {
      if (this.newmenuSrc.length != 0) {
        this.menuSrc = this.newmenuSrc.map(ele => ele)
        this.pdfRedirctVar = null
        this.pdfMenuSrc = 'null'
        this.stringOldMenu = JSON.stringify(this.menuSrc)
        this.stringNewMenu = JSON.stringify(this.newmenuSrc)
        this.stringOldPdfSrc = JSON.stringify(this.pdfRedirctVar)
        this.stringNewPdfSrc = JSON.stringify(this.newpdfRedirctVar)
      }
      else if (this.newpdfMenuSrc != 'null' && this.newmenuSrc.length == 0) {
        this.newpdfRedirctVar = this.pdfRedirctVar
        this.newpdfMenuSrc = this.pdfMenuSrc
        this.menuSrc = []
        this.menuImgToBeAppend = []
        this.stringOldMenu = JSON.stringify(this.menuSrc)
        this.stringNewMenu = JSON.stringify(this.newmenuSrc)
        this.stringOldPdfSrc = JSON.stringify(this.pdfRedirctVar)
        this.stringNewPdfSrc = JSON.stringify(this.newpdfRedirctVar)
      }
    }

    this.otherDescriptionOrTags = this.otherDescriptionOrTagsNew
  }

  copyToMain(name: string) {
    if (name == 'restoName') {
      this.restoName = this.restoNewName
    }
    else if (name == 'restoEmail') this.restoEmail = this.restoNewEmail
    else if (name == 'restoPhone') this.restoPhone = this.restoNewPhone
    else if (name == 'restoAddress') this.restoAddress = this.restoNewAddress
    else if (name == 'restoWebsite') this.restoWebsite = this.restoNewWebsite
    else if (name == 'restoDescription') this.restoDescription = this.restoNewDescription
    else if (name == 'restoAvgRating') this.restoAvgRating = this.restoNewAvgRating
    else if (name == 'cuisine') {

      this.selectedCuisine = this.selectedNewCuisine.map(ele => ele)
      this.stringSelectedCuisine = JSON.stringify(this.selectedCuisine)
      this.stringSelectedNewCuisine = JSON.stringify(this.selectedNewCuisine)
      let element = document.getElementById('cuisine').children
      let newElement = document.getElementById('cuisineNew').children
      for (let i = 0; i < element.length; i++) {
        if (newElement[i].children[0]['checked']) {
          element[i].children[0]['checked'] = true
        }
        else {
          element[i].children[0]['checked'] = false
        }
      }
    }
    else if (name == 'categories') {
      this.selectedCaategory = this.selectedNewCategories.map(ele => ele)
      this.stringSelectedCategory = JSON.stringify(this.selectedCaategory)
      this.stringSelectedNewCategory = JSON.stringify(this.selectedNewCategories)
      let element = document.getElementById('categories').children
      let newElement = document.getElementById('categoriesNew').children
      for (let i = 0; i < element.length; i++) {
        if (newElement[i].children[0]['checked']) {
          element[i].children[0]['checked'] = true
        }
        else {
          element[i].children[0]['checked'] = false
        }
      }
    }
    else if (name == 'dietPref') {
      this.selectedDieatry = this.selectedNewDietaer.map(ele => ele)
      this.stringSelectedDiet = JSON.stringify(this.selectedDieatry)
      this.stringSelectedNewDiet = JSON.stringify(this.selectedNewDietaer)
      let element = document.getElementById('dietPref').children
      let newElement = document.getElementById('dietPrefNew').children
      for (let i = 0; i < element.length; i++) {
        if (newElement[i].children[0]['checked']) {
          element[i].children[0]['checked'] = true
        }
        else {
          element[i].children[0]['checked'] = false
        }
      }
    }
    else if (name == 'allergien') {
      this.selectedAllegens = this.selectedNewAllergens.map(ele => ele)
      this.stringSelctedAllegens = JSON.stringify(this.selectedAllegens)
      this.stringSelctedNewAllegens = JSON.stringify(this.selectedNewAllergens)
      let element = document.getElementById('allergien').children
      let newElement = document.getElementById('allergienNew').children
      for (let i = 0; i < element.length; i++) {
        if (newElement[i].children[0]['checked']) {
          element[i].children[0]['checked'] = true
        }
        else {
          element[i].children[0]['checked'] = false
        }
      }
    }
    else if (name == 'specialOffer') {
      this.offerOldMonday = this.offerMonday
      this.offerOldTuesday = this.offerTuesday
      this.offerOldWednesday = this.offerWednesday
      this.offerOldTurusday = this.offerTurusday
      this.offerOldFriday = this.offerFriday
      this.offerOldSaturday = this.offerSaturday
      this.offerOldSunday = this.offerSunday
      this.offerOldMonValue = this.offerMonValue
      this.offerOldTueValue = this.offerTueValue
      this.offerOldWedValue = this.offerWedValue
      this.offerOldThurValue = this.offerThurValue
      this.offerOldFriValue = this.offerFriValue
      this.offerOldSatValue = this.offerSatValue
      this.offerOldSunValue = this.offerSunValue

    }
    else if (name == 'delivaryPartner') {
      this.delverooCon = this.delverooConNew
      this.justEatCon = this.justEatConNew
      this.uberEatsCon = this.uberEatsConNew
      this.foodstuffCon = this.foodstuffConNew
      this.delverooVal = this.delverooValNew
      this.justEatVal = this.justEatValNew
      this.uberEatsVal = this.uberEatsValNew
      this.foodstuffVal = this.foodstuffValNew

    }
    else if (name == 'socialLink') {
      this.instagramCon = this.instagramConNew
      this.facebookCon = this.facebookConNew
      this.googleMapCon = this.googleMapConNew
      this.instagramVal = this.instagramValNew
      this.facebookVal = this.facebookValNew
      this.googleMapVal = this.googleMapValNew
    }
    else if (name == 'message') {
      if (this.approAns == 'A' || this.approAns == 'B' || this.approAns == 'C')
        this.approOldAns = this.approAns
      else {
        this.approOldAns = this.approAns
        this.queAnsOtherText = this.queAnsOtherTextNew
      }
    }
    else if (name == 'logo') {
      this.src = this.NewSrc
      this.logoToBeAppend = null
    }
    else if (name == 'featureImg') {
      this.featureSrc = this.newfeatureSrc
      this.featureImgToBeAppend = null
    }
    else if (name == 'menuImg') {
      if (this.menuLinkConditionNew) {
        this.menuLinkCondition = true
        this.urlLink = this.urlLinkNew
      }
      else {
        if (this.newmenuSrc.length != 0) {
          this.menuSrc = this.newmenuSrc.map(ele => ele)
          this.pdfRedirctVar = null
          this.pdfMenuSrc = 'null'
          this.stringOldMenu = JSON.stringify(this.menuSrc)
          this.stringNewMenu = JSON.stringify(this.newmenuSrc)
          this.stringOldPdfSrc = JSON.stringify(this.pdfRedirctVar)
          this.stringNewPdfSrc = JSON.stringify(this.newpdfRedirctVar)
        }
        else if (this.newpdfMenuSrc != 'null' && this.newmenuSrc.length == 0) {
          this.newpdfRedirctVar = this.pdfRedirctVar
          this.newpdfMenuSrc = this.pdfMenuSrc
          this.menuSrc = []
          this.menuImgToBeAppend = []
          this.stringOldMenu = JSON.stringify(this.menuSrc)
          this.stringNewMenu = JSON.stringify(this.newmenuSrc)
          this.stringOldPdfSrc = JSON.stringify(this.pdfRedirctVar)
          this.stringNewPdfSrc = JSON.stringify(this.newpdfRedirctVar)
        }
      }
    }
    else if (name == 'otherDescriptionOrTags') {
      this.otherDescriptionOrTags = this.otherDescriptionOrTagsNew
    }

  }
  noResto
  claimRestoId
  getAllResto() {
    this.httpSv.getClaimedAllResto().subscribe(res => {
      if (res['status'] == 'TRUE') {
        this.allRestaurantList = []
        this.restaurantList = []
        this.l1_waiting_all_resto = []
        this.l1_approved_all_resto = []
        this.l2_all_resto = []
        this.l3_all_resto = []

        this.restaurantList = res["result"].data;
        this.allRestaurantList = [...this.restaurantList]

        this.restaurantList.forEach(element => {
          switch (element.level) {
            case 'Level 1 - Waiting':
              this.l1_waiting_all_resto.push(element);
              break;

            case 'Level 1 - Approved':
              this.l1_approved_all_resto.push(element);
              break;

            case 'Level 2':
              this.l2_all_resto.push(element);
              break;

            case 'Level 3':
              this.l3_all_resto.push(element);
              break;
            default:
              console.error('Level not found for', element)
              break;
          }
        })

        this.l1_waiting_all_resto.sort((a, b) => {
          return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
        }).reverse()
        this.l1_approved_all_resto.sort((a, b) => {
          return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
        }).reverse()
        this.l2_all_resto.sort((a, b) => {
          return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
        }).reverse()
        this.l3_all_resto.sort((a, b) => {
          return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
        }).reverse()


        this.restaurantList = this.l1_waiting ? this.l1_waiting_all_resto : this.l1_approved ? this.l1_approved_all_resto : this.l2 ? this.l2_all_resto : this.l3 ? this.l3_all_resto : this.allRestaurantList


        this.dataSource.data = this.restaurantList;
        // this.claimRestoId = res['result'].data.claim_restaurantId
        // this.dataSource = new MatTableDataSource (this.restaurantList)
        // this.dataSource.paginator = this.paginator1;
        setTimeout(() => this.dataSource.paginator = this.paginator1);
        this.noResto = res["result"].data.length;
        if (this.dataSource['_data']['_value']) {
          this.restofound = true
        }

      }
    })

  }
  getClaimedDate(date:any) {
    if (!date || String(date).startsWith('0000-00-00')) {
      return 'N/A';
    }
    return String(date).split(' ')[0];
  }
  timeInputFunc(data, id) {

  }
  offerHandelFunc(day, e) {
    if (e.checked) {
      if (day == 'mon') {
        this.offerMonday = true
      }
      else if (day == 'tue') {
        this.offerTuesday = true
      }
      else if (day == 'wed') {
        this.offerWednesday = true
      }
      else if (day == 'thu') {
        this.offerTurusday = true
      }
      else if (day == 'fri') {
        this.offerFriday = true
      }
      else if (day == 'sat') {
        this.offerSaturday = true
      }
      else if (day == 'sun') {
        this.offerSunday = true
      }
      else if (day == 'monOld') {
        this.offerOldMonday = true
      }
      else if (day == 'tueOld') {
        this.offerOldTuesday = true
      }
      else if (day == 'wedOld') {
        this.offerOldWednesday = true
      }
      else if (day == 'thuOld') {
        this.offerOldTurusday = true
      }
      else if (day == 'friOld') {
        this.offerOldFriday = true
      }
      else if (day == 'satOld') {
        this.offerOldSaturday = true
      }
      else if (day == 'sunOld') {
        this.offerOldSunday = true
      }
    }
    else {
      if (day == 'mon') {
        this.offerMonday = false
      }
      else if (day == 'tue') {
        this.offerTuesday = false
      }
      else if (day == 'wed') {
        this.offerWednesday = false
      }
      else if (day == 'thu') {
        this.offerTurusday = false
      }
      else if (day == 'fri') {
        this.offerFriday = false
      }
      else if (day == 'sat') {
        this.offerSaturday = false
      }
      else if (day == 'sun') {
        this.offerSunday = false
      }
      else if (day == 'monOld') {
        this.offerOldMonday = false
      }
      else if (day == 'tueOld') {
        this.offerOldTuesday = false
      }
      else if (day == 'wedOld') {
        this.offerOldWednesday = false
      }
      else if (day == 'thuOld') {
        this.offerOldTurusday = false
      }
      else if (day == 'friOld') {
        this.offerOldFriday = false
      }
      else if (day == 'satOld') {
        this.offerOldSaturday = false
      }
      else if (day == 'sunOld') {
        this.offerOldSunday = false
      }

    }
  }
  onImageChange(event, id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    if (fileSize > 500) {
      this._snackBar.open(`Image can't be uploaded, as the size is bigger than 500 kb`)
      setTimeout(() => { this._snackBar.dismiss() }, 3000)
      document.getElementById(id)['value'] = ''
      return
    }
    this.logoToBeAppend = event.target.files[0]
    let file: File = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.src = e.target.result;
      document.getElementById(id)['value'] = ''
    };
  }
  onFeatureImgChange(event, id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    if (fileSize > 500) {
      this._snackBar.open(`Image can't be uploaded, as the size is bigger than 500 kb`)
      setTimeout(() => { this._snackBar.dismiss() }, 3000)
      document.getElementById(id)['value'] = ''
      // alert(`Sorry this is can't be uploaded .The image size is greater than 500kb`)
      return
    }
    this.featureImgToBeAppend = event.target.files[0]
    let file: File = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.featureSrc = e.target.result;
      document.getElementById(id)['value'] = ''
    };
  }
  menuImgDelete(index, src) {
    if (src.src.includes('base64')) {
      let reqIndex = this.menuImgToBeAppend.findIndex(ele => ele.name == src.name)
      this.menuSrc.splice(index, 1)
      this.menuImgToBeAppend.splice(reqIndex, 1)
    }
    else {
      this.menuSrc.splice(index, 1)
    }
    this.stringOldMenu = JSON.stringify(this.menuSrc)
    this.stringNewMenu = JSON.stringify(this.newmenuSrc)
    this.stringOldPdfSrc = JSON.stringify(this.pdfRedirctVar)
    this.stringNewPdfSrc = JSON.stringify(this.newpdfRedirctVar)
  }
  onMenuChange(event, id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    if (fileSize > 500) {
      this._snackBar.open(`Image can't be uploaded, as the size is bigger than 500 kb`)
      setTimeout(() => { this._snackBar.dismiss() }, 3000)
      document.getElementById(id)['value'] = ''
      // alert(`Sorry this is can't be uploaded .The image size is greater than 500kb`)
      return
    }
    this.menuLinkCondition = false
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      let temp = event.target.files[0].name.split('.')
      if (temp[temp.length - 1] != 'pdf') {
        this.menuImgToBeAppend.push(event.target.files[0])
        this.menuPdfToBeAppend = null
        this.menuSrc.push({ src: e.target.result, name: event.target.files[0].name })
        this.stringOldMenu = JSON.stringify(this.menuSrc)
        this.stringNewMenu = JSON.stringify(this.newmenuSrc)
        this.stringOldPdfSrc = JSON.stringify(this.pdfRedirctVar)
        this.stringNewPdfSrc = JSON.stringify(this.newpdfRedirctVar)
        document.getElementById(id)['value'] = ''
      }
      else {
        this.pdfUploadCheckFunc(event, id)
      }
    }
  }
  pdfUploadCheckFunc(data, id) {
    if (this.menuSrc.length != 0) {
      let con = confirm('Are you sure to upload the pdf , this will delete the images')
      if (con) {
        this.menuSrc = []
        this.menuImgToBeAppend = []
        this.onMenuPdfChange(data, id)

      }
      else {
        document.getElementById(id)['value'] = ''
      }
    }
    else {
      this.onMenuPdfChange(data, id)
    }
  }
  onMenuPdfChange(event, id) {
    this.menuPdfToBeAppend = event.target.files[0]
    this.pdfMenuSrc = event.target.files[0].name
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.pdfRedirctVar = e.target.result
      document.getElementById(id)['value'] = ''
      this.menuSrc = []
      this.menuImgToBeAppend = []
    };
    this.stringOldMenu = JSON.stringify(this.menuSrc)
    this.stringNewMenu = JSON.stringify(this.newmenuSrc)
    this.stringOldPdfSrc = JSON.stringify(this.pdfRedirctVar)
    this.stringNewPdfSrc = JSON.stringify(this.newpdfRedirctVar)

  }
  openpdf() {
    window.open(this.pdfRedirctVar)
  }
  pdfDelete() {
    if (this.menuImgToBeAppend) {
      this.pdfMenuSrc = 'null'
      this.menuPdfToBeAppend = null
    }
  }
  menuLinkInsert() {
    this.menuLinkCondition = true
  }

  preSelectFunc(name, id) {
    if (name == 'cuisineNew') {
      return this.selectedNewCuisine.includes(id)
    }
    else if (name == 'categoriesNew') {
      return this.selectedNewCategories.includes(id)
    }
    else if (name == 'dietPrefNew') {
      return this.selectedNewDietaer.includes(id)
    }
    else if (name == 'allergienNew') {
      return this.selectedNewAllergens.includes(id)
    }
    else if (name == 'cuisine') {
      return this.selectedCuisine.includes(id)
    }
    else if (name == 'categories') {
      return this.selectedCaategory.includes(id)
    }
    else if (name == 'allergien') {
      return this.selectedAllegens.includes(id)
    }
    else if (name == 'dietPref') {
      return this.selectedDieatry.includes(id)
    }
  }
  checkChangeHandle(name, id, e) {
    if (e.checked) {
      if (name == 'cuisine') {
        this.selectedCuisine.push(id)
        this.stringSelectedCuisine = JSON.stringify(this.selectedCuisine)
      }
      else if (name == 'categories') {
        this.selectedCaategory.push(id)
        this.stringSelectedCategory = JSON.stringify(this.selectedCaategory)
      }
      else if (name == 'allergien') {
        this.selectedAllegens.push(id)
        this.stringSelctedAllegens = JSON.stringify(this.selectedAllegens)
      }
      else if (name == 'dietPref') {
        this.selectedDieatry.push(id)
        this.stringSelectedDiet = JSON.stringify(this.selectedDieatry)
      }
    }
    else {
      if (name == 'cuisine') {
        let index = this.selectedCuisine.findIndex(ele => ele == id)
        this.selectedCuisine.splice(index, 1)
        this.stringSelectedCuisine = JSON.stringify(this.selectedCuisine)
      }
      else if (name == 'categories') {
        let index = this.selectedCaategory.findIndex(ele => ele == id)
        this.selectedCaategory.splice(index, 1)
        this.stringSelectedCategory = JSON.stringify(this.selectedCaategory)
      }
      else if (name == 'allergien') {
        let index = this.selectedAllegens.findIndex(ele => ele == id)
        this.selectedAllegens.splice(index, 1)
        this.stringSelctedAllegens = JSON.stringify(this.selectedAllegens)
      }
      else if (name == 'dietPref') {
        let index = this.selectedDieatry.findIndex(ele => ele == id)
        this.selectedDieatry.splice(index, 1)
        this.stringSelectedDiet = JSON.stringify(this.selectedDieatry)
      }
    }
  }
  timeCopyFunc() {
    this.oldmonOpenHH = this.monOpenHH
    this.oldmonOpenMM = this.monOpenMM
    this.oldmonOpenMead = this.monOpenMead
    this.oldmonPrecheck = this.monPrecheck
    this.oldmonCloseHH = this.monCloseHH
    this.oldmonCloseMM = this.monCloseMM
    this.oldmonCloseMead = this.monCloseMead
    this.oldtueOpenHH = this.tueOpenHH
    this.oldtueOpenMM = this.tueOpenMM
    this.oldtueOpenMead = this.tueCloseMead
    this.oldtueCloseHH = this.tueCloseHH
    this.oldtueCloseMM = this.tueCloseMM
    this.oldtueCloseMead = this.tueCloseMead
    this.oldtuePrecheck = this.tuePrecheck
    this.oldwedOpenHH = this.wedOpenHH
    this.oldwedOpenMM = this.wedOpenMM
    this.oldwedOpenMead = this.wedOpenMead
    this.oldwedCloseHH = this.wedCloseHH
    this.oldwedCloseMM = this.wedCloseMM
    this.oldwedCloseMead = this.wedCloseMead
    this.oldwedPrecheck = this.wedPrecheck
    this.oldthurOpenHH = this.thurOpenHH
    this.oldthurOpenMM = this.thurOpenMM
    this.oldthurOpenMead = this.thurOpenMead
    this.oldthurCloseHH = this.thurCloseHH
    this.oldthurCloseMM = this.thurCloseMM
    this.oldthurCloseMead = this.thurCloseMead
    this.oldthurPrecheck = this.thurPrecheck
    this.oldfriOpenHH = this.friOpenHH
    this.oldfriOpenMM = this.friOpenMM
    this.oldfriOpenMead = this.friOpenMead
    this.oldfriCloseHH = this.friCloseHH
    this.oldfriCloseMM = this.friCloseMM
    this.oldfriCloseMead = this.friCloseMead
    this.oldfriPrecheck = this.friPrecheck
    this.oldsatOpenHH = this.satOpenHH
    this.oldsatOpenMM = this.satOpenMM
    this.oldsatOpenMead = this.satOpenMead
    this.oldsatCloseHH = this.satCloseHH
    this.oldsatCloseMM = this.satCloseMM
    this.oldsatCloseMead = this.satCloseMead
    this.oldsatPrecheck = this.satPrecheck
    this.oldsunOpenHH = this.sunOpenHH
    this.oldsunOpenMM = this.sunOpenMM
    this.oldsunOpenMead = this.sunOpenMead
    this.oldsunCloseHH = this.sunCloseHH
    this.oldsunCloseMM = this.sunCloseMM
    this.oldsunCloseMead = this.sunCloseMead
    this.oldsunPrecheck = this.sunPrecheck

    document.getElementById('timeOldMon')['checked'] = document.getElementById('timeNewMon')['checked']
    document.getElementById('timeOldTue')['checked'] = document.getElementById('timeNewTue')['checked']
    document.getElementById('timeOldWed')['checked'] = document.getElementById('timeNewWed')['checked']
    document.getElementById('timeOldThu')['checked'] = document.getElementById('timeNewThu')['checked']
    document.getElementById('timeOldFri')['checked'] = document.getElementById('timeNewFri')['checked']
    document.getElementById('timeOldSat')['checked'] = document.getElementById('timeNewSat')['checked']
    document.getElementById('timeOldSun')['checked'] = document.getElementById('timeNewSun')['checked']

  }
  timeEdit(day, e) {
    if (e.checked) {
      if (day == 'mon') {
        this.oldmonPrecheck = true
      }
      else if (day == 'tue') {
        this.oldtuePrecheck = true
      }
      else if (day == 'wed') {
        this.oldwedPrecheck = true
      }
      else if (day == 'thu') {
        this.oldthurPrecheck = true
      }
      else if (day == 'fri') {
        this.oldfriPrecheck = true
      }
      else if (day == 'sat') {
        this.oldsatPrecheck = true
      }
      else if (day == 'sun') {
        this.oldsunPrecheck = true
      }
    }
    else {
      if (day == 'mon') {
        this.oldmonPrecheck = false
      }
      else if (day == 'tue') {
        this.oldtuePrecheck = false
      }
      else if (day == 'wed') {
        this.oldwedPrecheck = false
      }
      else if (day == 'thu') {
        this.oldthurPrecheck = false
      }
      else if (day == 'fri') {
        this.oldfriPrecheck = false
      }
      else if (day == 'sat') {
        this.oldsatPrecheck = false
      }
      else if (day == 'sun') {
        this.oldsunPrecheck = false
      }
    }
  }
  queAnsFunc(ver, option) {
    if (ver == 'new') {
      if (option == this.approAns) return true
      else return false
    }
    else if (ver == 'old') {
      if (option == this.approOldAns) return true
      else return false
    }
  }
  messageChange(option) {
    this.approOldAns = option
  }
  closeFunc() {
    this.getAllResto()
    this.restopop = 0
    this.claimRestoId = null
    this.monOpenHH = ''
    this.monOpenMM = ''
    this.monOpenMead = 'am'
    this.monPrecheck
    this.monCloseHH = ''
    this.monCloseMM = ''
    this.monCloseMead = 'am'
    this.tueOpenHH = ''
    this.tueOpenMM = ''
    this.tueOpenMead = 'am'
    this.tueCloseHH = ''
    this.tueCloseMM = ''
    this.tueCloseMead = 'am'
    this.tuePrecheck
    this.wedOpenHH = ''
    this.wedOpenMM = ''
    this.wedOpenMead = 'am'
    this.wedCloseHH = ''
    this.wedCloseMM = ''
    this.wedCloseMead = 'am'
    this.wedPrecheck
    this.thurOpenHH = ''
    this.thurOpenMM = ''
    this.thurOpenMead = 'am'
    this.thurCloseHH = ''
    this.thurCloseMM = ''
    this.thurCloseMead = 'am'
    this.thurPrecheck
    this.friOpenHH = ''
    this.friOpenMM = ''
    this.friOpenMead = 'am'
    this.friCloseHH = ''
    this.friCloseMM = ''
    this.friCloseMead = 'am'
    this.friPrecheck
    this.satOpenHH = ''
    this.satOpenMM = ''
    this.satOpenMead = 'am'
    this.satCloseHH = ''
    this.satCloseMM = ''
    this.satCloseMead = 'am'
    this.satPrecheck
    this.sunOpenHH = ''
    this.sunOpenMM = ''
    this.sunOpenMead = 'am'
    this.sunCloseHH = ''
    this.sunCloseMM = ''
    this.sunCloseMead = 'am'
    this.sunPrecheck

    this.oldmonOpenHH = ''
    this.oldmonOpenMM = ''
    this.oldmonOpenMead = 'am'
    this.oldmonPrecheck
    this.oldmonCloseHH = ''
    this.oldmonCloseMM = ''
    this.oldmonCloseMead = 'am'
    this.oldtueOpenHH = ''
    this.oldtueOpenMM = ''
    this.oldtueOpenMead = 'am'
    this.oldtueCloseHH = ''
    this.oldtueCloseMM = ''
    this.oldtueCloseMead = 'am'
    this.oldtuePrecheck
    this.oldwedOpenHH = ''
    this.oldwedOpenMM = ''
    this.oldwedOpenMead = 'am'
    this.oldwedCloseHH = ''
    this.oldwedCloseMM = ''
    this.oldwedCloseMead = 'am'
    this.oldwedPrecheck
    this.oldthurOpenHH = ''
    this.oldthurOpenMM = ''
    this.oldthurOpenMead = 'am'
    this.oldthurCloseHH = ''
    this.oldthurCloseMM = ''
    this.oldthurCloseMead = 'am'
    this.oldthurPrecheck
    this.oldfriOpenHH = ''
    this.oldfriOpenMM = ''
    this.oldfriOpenMead = 'am'
    this.oldfriCloseHH = ''
    this.oldfriCloseMM = ''
    this.oldfriCloseMead = 'am'
    this.oldfriPrecheck
    this.oldsatOpenHH = ''
    this.oldsatOpenMM = ''
    this.oldsatOpenMead = 'am'
    this.oldsatCloseHH = ''
    this.oldsatCloseMM = ''
    this.oldsatCloseMead = 'am'
    this.oldsatPrecheck
    this.oldsunOpenHH = ''
    this.oldsunOpenMM = ''
    this.oldsunOpenMead = 'am'
    this.oldsunCloseHH = ''
    this.oldsunCloseMM = ''
    this.oldsunCloseMead = 'am'
    this.oldsunPrecheck

    this.offerMonday = false
    this.offerTuesday = false
    this.offerWednesday = false
    this.offerTurusday = false
    this.offerFriday = false
    this.offerSaturday = false
    this.offerSunday = false
    this.offerMonValue = ''
    this.offerTueValue = ''
    this.offerWedValue = ''
    this.offerThurValue = ''
    this.offerFriValue = ''
    this.offerSatValue = ''
    this.offerSunValue = ''

    this.offerOldMonday = false
    this.offerOldTuesday = false
    this.offerOldWednesday = false
    this.offerOldTurusday = false
    this.offerOldFriday = false
    this.offerOldSaturday = false
    this.offerOldSunday = false
    this.offerOldMonValue = ''
    this.offerOldTueValue = ''
    this.offerOldWedValue = ''
    this.offerOldThurValue = ''
    this.offerOldFriValue = ''
    this.offerOldSatValue = ''
    this.offerOldSunValue = ''

    this.src = "../../../assets/images/Ellipse 11.png";
    this.NewSrc = "../../../assets/images/Ellipse 11.png";
    this.featureSrc = "../../../assets/images/Ellipse 11.png";
    this.newfeatureSrc = "../../../assets/images/Ellipse 11.png";
    this.logoToBeAppend = null
    this.featureImgToBeAppend = null
    this.menuSrc = []
    this.newmenuSrc = []
    // this.menuPdfCondition
    // this.menuImgCondition
    this.pdfConditionMenu = false
    this.imgConditionMenu = false
    this.menuLinkCondition = false
    this.menuImgToBeAppend = []
    this.menuPdfToBeAppend = null
    this.pdfMenuSrc = 'null'
    this.newpdfMenuSrc = 'null'
    this.pdfRedirctVar = null
    this.newpdfRedirctVar = null
    this.stringOldMenu = null
    this.stringNewMenu = null
    this.stringNewPdfSrc = null
    this.stringOldPdfSrc = null
    this.allDieatary = [];
    this.allAllergens = []
    this.allCaategory = []
    this.allCuisine = []
    this.selectedDieatry = []
    this.selectedAllegens = []
    this.selectedCaategory = []
    this.selectedCuisine = []
    this.restofound = false
    this.searchText = ''
    this.restaurantList = []
    this.delverooCon = false
    this.justEatCon = false
    this.uberEatsCon = false
    this.foodstuffCon = false
    this.delverooVal = null
    this.justEatVal = null
    this.uberEatsVal = null
    this.foodstuffVal = null
    this.delverooConNew = false
    this.justEatConNew = false
    this.uberEatsConNew = false
    this.foodstuffConNew = false
    this.delverooValNew = null
    this.justEatValNew = null
    this.uberEatsValNew = null
    this.foodstuffValNew = null


    this.instagramCon = false
    this.facebookCon = false
    this.googleMapCon = false
    this.instagramVal = null
    this.facebookVal = null
    this.googleMapVal = null
    this.instagramConNew = false
    this.facebookConNew = false
    this.googleMapConNew = false
    this.instagramValNew = null
    this.facebookValNew = null
    this.googleMapValNew = null
    this.approAns = null
    this.approOldAns = null
    this.queAnsOtherTextNew = ''
    this.queAnsOtherText = ''
    this.otherDescriptionOrTags = ''
    this.otherDescriptionOrTagsNew = ''
    // this.sendData.foreach((val,key)=>{
    //   this.sendData.delete(key)
    // })
    this.sendData = new FormData()
  }
  delverooCon = false
  justEatCon = false
  uberEatsCon = false
  foodstuffCon = false
  delverooVal
  justEatVal
  uberEatsVal
  foodstuffVal
  delverooConNew = false
  justEatConNew = false
  uberEatsConNew = false
  foodstuffConNew = false
  delverooValNew
  justEatValNew
  uberEatsValNew
  foodstuffValNew
  delevryHandelFunc(name, event) {
    if (event.checked) {
      if (name == 'deliveroo') this.delverooCon = true
      else if (name == 'justEat') this.justEatCon = true
      else if (name == 'uberEats') this.uberEatsCon = true
      else if (name == 'foodstuff') this.foodstuffCon = true
    }
    else {
      if (name == 'deliveroo') this.delverooCon = false
      else if (name == 'justEat') this.justEatCon = false
      else if (name == 'uberEats') this.uberEatsCon = false
      else if (name == 'foodstuff') this.foodstuffCon = false
    }
  }
  instagramCon = false
  facebookCon = false
  googleMapCon = false
  instagramVal
  facebookVal
  googleMapVal
  instagramConNew = false
  facebookConNew = false
  googleMapConNew = false
  instagramValNew
  facebookValNew
  googleMapValNew
  socialLinkHandelFunc(name, event) {
    if (event.checked) {
      if (name == 'facebook') this.facebookCon = true
      else if (name == 'instagram') this.instagramCon = true
      else if (name == 'googleMap') this.googleMapCon = true
    }
    else {
      if (name == 'facebook') this.facebookCon = false
      else if (name == 'instagram') this.instagramCon = false
      else if (name == 'googleMap') this.googleMapCon = false
    }
  }
  sendData: any = new FormData()
  updatedClaimedFunc() {
    this.sendData.append('restaurant_name', this.restoName)
    this.sendData.append('restaurant_email', this.restoEmail)
    this.sendData.append('restaurant_telephone', this.restoPhone)
    this.sendData.append('restaurant_description', this.restoDescription)
    this.sendData.append('restaurant_address', this.restoAddress)
    this.sendData.append('cuisine', this.selectedCuisine)
    this.sendData.append('category', this.selectedCaategory)
    this.sendData.append('allergens', this.selectedAllegens)
    this.sendData.append('dietary_preferences', this.selectedDieatry)
    this.sendData.append('average_rating', this.restoAvgRating)
    if (this.src != '../../../assets/images/Ellipse 11.png') {
      if (this.logoToBeAppend) this.sendData.append('logo', this.logoToBeAppend)
      else this.sendData.append('logo', this.src)
    }
    if (this.featureSrc != '../../../assets/images/Ellipse 11.png') {
      if (this.featureImgToBeAppend) this.sendData.append('featured_image', this.featureImgToBeAppend)
      else this.sendData.append('featured_image', this.featureSrc)
    }
    let mon = this.oldmonPrecheck ? "Monday:" + this.oldmonOpenHH + ":" + this.oldmonOpenMM + ":" + this.oldmonOpenMead + ':' + this.oldmonCloseHH + ':' + this.oldmonCloseMM + ':' + this.oldmonCloseMead : "Monday:null"
    let tue = this.oldtuePrecheck ? `Tuesday:${this.oldtueOpenHH}:${this.oldtueOpenMM}:${this.oldtueOpenMead}:${this.oldtueCloseHH}:${this.oldtueCloseMM}:${this.oldtueCloseMead}` : 'Tuesday:null'
    let wed = this.oldwedPrecheck ? `Wednesday:${this.oldwedOpenHH}:${this.oldwedOpenMM}:${this.oldwedOpenMead}:${this.oldwedCloseHH}:${this.oldwedCloseMM}:${this.oldwedCloseMead}` : 'Wednesday:null'
    let thur = this.oldthurPrecheck ? `Thursday:${this.oldthurOpenHH}:${this.oldthurOpenMM}:${this.oldthurOpenMead}:${this.oldthurCloseHH}:${this.oldthurCloseMM}:${this.oldthurCloseMead}` : 'Thursday:null'
    let fri = this.oldfriPrecheck ? `Friday:${this.oldfriOpenHH}:${this.oldfriOpenMM}:${this.oldfriOpenMead}:${this.oldfriCloseHH}:${this.oldfriCloseMM}:${this.oldfriCloseMead}` : 'Friday:null'
    let sat = this.oldsatPrecheck ? `Saturday:${this.oldsatOpenHH}:${this.oldsatOpenMM}:${this.oldsatOpenMead}:${this.oldsatCloseHH}:${this.oldsatCloseMM}:${this.oldsatCloseMead}` : 'Saturday:null'
    let sun = this.oldsunPrecheck ? `Sunday:${this.oldsunOpenHH}:${this.oldsunOpenMM}:${this.oldsunOpenMead}:${this.oldsunCloseHH}:${this.oldsunCloseMM}:${this.oldsunCloseMead}` : 'Sunday:null'
    let time = `${mon},${tue},${wed},${thur},${fri},${sat},${sun}`
    this.sendData.append('opening_hours', time)

    let monOffer = this.offerOldMonday ? "Monday:" + this.offerOldMonValue : "Monday:null"
    let tueOffer = this.offerOldTuesday ? "Tuesday:" + this.offerOldTueValue : "Tuesday:null"
    let wedOffer = this.offerOldWednesday ? "Wednesday:" + this.offerOldWedValue : "Wednesday:null"
    let thurOffer = this.offerOldTurusday ? "Thursday:" + this.offerOldThurValue : "Thursday:null"
    let friOffer = this.offerOldFriday ? "Friday:" + this.offerOldFriValue : "Friday:null"
    let satOffer = this.offerOldSaturday ? "Saturday:" + this.offerOldSatValue : "Saturday:null"
    let sunOffer = this.offerOldSunday ? "Sunday:" + this.offerOldSunValue : "Sunday:null"
    let finalOffer = `${monOffer},${tueOffer},${wedOffer},${thurOffer},${friOffer},${satOffer},${sunOffer}`
    this.sendData.append('special_offer', finalOffer)
    if (this.menuLinkCondition) {
      this.sendData.append('menu_name_link[]', this.urlLink)
    }
    else {
      if (this.pdfRedirctVar) {
        if (this.menuPdfToBeAppend) {
          this.sendData.append('menu_name[]', this.menuPdfToBeAppend)
        }
        else {
          this.sendData.append('menu_name_link[]', this.pdfMenuSrc)
        }
      }
      else if (this.menuSrc.length > 0) {
        let link = []
        if (this.menuSrc.length == this.menuImgToBeAppend.length) {
          this.menuImgToBeAppend.forEach(ele => {
            this.sendData.append('menu_name[]', ele)
          })
        }
        else {
          if (this.menuImgToBeAppend.length > 0) {
            this.menuImgToBeAppend.forEach(ele => {
              this.sendData.append('menu_name[]', ele)
            })
          }
          this.menuSrc.forEach(ele => {
            // if (ele.src.includes('http')) this.sendData.append('menu_name_link[]', ele.src)
            if (ele.src.includes('http')) link.push(ele.src)
          })
          this.sendData.append('menu_name_link[]', link)
        }
      }
    }
    // if (this.approOldAns) this.sendData.append('appropriate_food_allergy_message', this.approOldAns)
    if (this.approOldAns && this.approOldAns != 'D') this.sendData.append('appropriate_food_allergy_message', this.approOldAns)
    else if (this.approOldAns && this.approOldAns == 'D') this.sendData.append('appropriate_food_allergy_message', this.queAnsOtherText)
    let deleviroo = this.delverooCon ? 'Deliveroo:' + this.delverooVal : 'Deliveroo:null'
    let justeat = this.justEatCon ? 'JustEat:' + this.justEatVal : 'JustEat:null'
    let ubereat = this.uberEatsCon ? 'UberEats:' + this.uberEatsVal : 'UberEats:null'
    let foodstuf = this.foodstuffCon ? 'Foodstuff:' + this.foodstuffVal : 'Foodstuff:null'
    let deleveryPartner = `${deleviroo},${justeat},${ubereat},${foodstuf}`
    this.sendData.append('delivery_partner', deleveryPartner)
    if (this.instagramCon) this.sendData.append('instagram_link', this.instagramVal)
    else this.sendData.append('instagram_link', null)
    if (this.facebookCon) this.sendData.append('social_link', this.facebookVal)
    if (this.googleMapCon) this.sendData.append('google_map_url', this.googleMapVal)
    else this.sendData.append('google_map_url', null)
    if (this.otherDescriptionOrTags.length > 0) this.sendData.append('description_and_tags', this.otherDescriptionOrTags)
    this.sendData.append('restaurant_poc_name', 'fromSuperAdmin')
    this.sendData.append('restaurant_poc_number', '000')
    // this.sendData.append('restaurant_spice_tollerence', '1')
    this.sendData.append('claim_restaurantId', this.selectedClaimedResto.id)
    this.sendData.append('restaurant_lat', this.restoLat)
    this.sendData.append('restaurant_long', this.restoLong)
    this.httpSv.approveRestaurant(this.sendData).subscribe(res => {
      if (res['status'] == 'TRUE') {
        this._snackBar.open('Resturant approved')
        setTimeout(() => {
          this._snackBar.dismiss()
        }, 2000)
        this.closeFunc()

      }
      else {
        this._snackBar.open(res['message'])
        setTimeout(() => {
          this._snackBar.dismiss()
        })

      }
    }, (err: any) => {
      this._snackBar.open('Something went wrong')
      setTimeout(() => {
        this._snackBar.dismiss()
      })
    })
  }
  openMenuUrlLink(url) {
    window.open(url)
  }
  validateNum(event) {
    let k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k >= 48 && k <= 57) || k == 43 || k == 32);
  }


  openDialog(id) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      data: "claim restaurant",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "true") {
        this.httpSv.deleteClaimResto(id).subscribe((res: any) => {
          if (res['status'] == 'TRUE') {
            this._snackBar.open('Claimed Resturant deleted')
            setTimeout(() => {
              this._snackBar.dismiss()
            }, 2000)
            this.getAllResto()
          }
        }, (err: any) => {
          this._snackBar.open('Something went wrong')
          setTimeout(() => {
            this._snackBar.dismiss()
          })
        })
      }
    });
  }
}



import { Clipboard } from '@angular/cdk/clipboard';
import { Router } from '@angular/router';
import { DeletePopupComponent } from '../delete-popup/delete-popup.component';
@Component({
  selector: 'app-partial-claim-resto',
  templateUrl: './partial_claim_resto_list.html',
  styleUrls: ['./d2-all-resto.component.scss']
})
export class PartialClaimRestoComponent implements OnInit {
  constructor(
    private httpSv: HttpService,
    private _snackBar: MatSnackBar,
    private clipboard: Clipboard,
    private router: Router,
    private dialog: MatDialog
  ) { }
  ngOnInit() {
    this.getAllPartialResto()
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator1;
  }
  allPartialResto = []
  @ViewChild(MatPaginator) paginator1: MatPaginator;


  searchText = ''
  displayedColumns: string[] = [
    "id",
    "name",
    "email",
    // "link",
    "sendEmail",
    "delete"
  ];

  dataSource: MatTableDataSource<[]> = new MatTableDataSource(
    this.allPartialResto
  );
  filter() {
    // console.log(this.dataSource)
    if (this.searchText == "") {
      this.dataSource = new MatTableDataSource(this.allPartialResto);
      this.dataSource.paginator = this.paginator1;
    } else {
      let temp = this.allPartialResto.filter((ele: any) => {
        return ele.resto_name
          .toLocaleLowerCase()
          .match(this.searchText.toLocaleLowerCase());
      });
      this.dataSource = new MatTableDataSource(temp);

      if (temp.length === 0) {
        let temp = this.allPartialResto.filter((ele: any) => {
          return ele.id
            .toLocaleLowerCase()
            .match(this.searchText.toLocaleLowerCase());
        });
        this.dataSource = new MatTableDataSource(temp);
      }
      this.dataSource.paginator = this.paginator1;
    }
  }


  copyToClipboard(element: any, tooltip: any) {
    let url = this.router.url;
    url = url.split('#')[0];
    this.clipboard.copy(window.location.origin + '#/business/claim?part=true&ri=' + element.id + '&sc=1&ps=2&em=true');
    element.tooltipText = 'Copied!';
    tooltip.show();

    setTimeout(() => {
      tooltip.hide();
    }, 3000);
  }

  resetTooltip(element: any) {
    element.tooltipText = 'Copy Link';
  }

  getAllPartialResto() {
    this.httpSv.getAllPartialRestoDtls().subscribe(res => {
      if (res['status'] == 'TRUE') {
        this.allPartialResto = res["result"].data;
        this.dataSource.data = res["result"].data;
        setTimeout(() => this.dataSource.paginator = this.paginator1);
      }
    }, err => {
    })
  }


  deleteResto(element: any) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      data: "restaturant",
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result == "true") {
          this.httpSv.deletePartialRestoById(element.id).subscribe(res => {
            if (res['status'] == 'TRUE') {
              this._snackBar.open('Restaurant deleted')
              setTimeout(() => {
                this._snackBar.dismiss()
              }, 2000)
              this.getAllPartialResto()
            }
          }, err => {
            this._snackBar.open('Something went wrong')
            setTimeout(() => {
              this._snackBar.dismiss()
            })
          })
        }
      }
    );
  }
  sendEmail(element: any) {
    console.log(element)
    let payload = {
      "restaurant_id": element.id,
      "restaurant_email": element.email,
      "restaurant_name": element.resto_name,
    }

    this.httpSv.sendEmailToPartialResto(payload).subscribe(res => {
      if (res['status'] == 'TRUE') {
        this._snackBar.open('Email sent successfully')
        setTimeout(() => {
          this._snackBar.dismiss()
        }, 2000)
      }
    }, err => {
      this._snackBar.open('Something went wrong')
      setTimeout(() => {
        this._snackBar.dismiss()
      })
    })
  }
}
